

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import '../../Styles/ManagementPages.css';
import {
  getBusOwners,
  getBusOwnerById,
  createBusOwner,
  updateBusOwner,
  deleteBusOwner,
  approveBusOwner,
  addBusToOwner,
  getSeatLayoutsByBustype,
  getAllCategory,
   getPendingBusOwners,
    approvePendingBusOwner,
    rejectPendingBusOwner,
    getPendingBusOwnerById,
    updatePendingBusOwner,
} from '../../Services/Operations/ProductAPI';
import {
  getDriversByBusOwner,
  getConductorsByBusOwner,
  assignDriverToBus,
  assignConductorToBus,
  unassignDriverFromBus,
  unassignConductorFromBus
} from '../../Services/Operations/ProductAPI';
import { toast } from 'react-toastify';
import '../../Styles/BusFareChart.css';
import { getAllBusownerAdminRoutes } from '../../Services/Operations/ProductAPI';
import BusManagementModal from './BusManagementModal';
import { useNavigate } from 'react-router-dom';

const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    <div className="skeleton-subtitle"></div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-avatar"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-actions"></div></td>
  </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>No.</th>
          <th>Profile</th>
          <th>Owner Name</th>
          <th>Company</th>
          <th>Contact</th>
          <th>Buses</th>
          <th>Admin Approval</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const SkeletonModal = () => (
  <div className="modal-overlay">
    <div className="modern-dashboard-modal skeleton">
      <div className="dashboard-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="dashboard-body">
        <div className="skeleton-profile-section"></div>
        <div className="skeleton-stats-strip"></div>
        <div className="skeleton-routes-section"></div>
        <div className="skeleton-buses-section"></div>
      </div>
      <div className="dashboard-footer">
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const RouteSelector = ({ value, onChange, onAddNew, token, disabled, loadingRoutes, originCity, destinationCity }) => {
  const [routes, setRoutes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchRoutes = async () => {
    setIsLoading(true);
    try {
      const response = await getAllBusownerAdminRoutes(
        token,
        1,
        100,
        searchTerm,
        '', {
          originCity,
          destinationCity
        }
      );
      console.log("getAllBusownerAdminRoutes :::::::::::: ",response)
      if (response && response.success && response.routes) {
        setRoutes(response.routes);
      }
    } catch (error) {
      console.error('Error fetching routes:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (showDropdown) {
      fetchRoutes();
    }
  }, [showDropdown, searchTerm, originCity, destinationCity]);

  const handleSelect = (route) => {
    onChange(route);
    setShowDropdown(false);
    setSearchTerm('');
  };

  return (
    <div className="master-route-selector" style={{ position: 'relative', width: '100%' }}>
      <div className="selector-input-group" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <div style={{ flex: 1, position: 'relative' }}>
          <input
            type="text"
            value={value ? value.routeName || value.masterRouteName : searchTerm}
            onClick={() => setShowDropdown(!showDropdown)}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setShowDropdown(true);
              if (value) onChange(null);
            }}
            placeholder="Select or search route..."
            className="modern-input"
            disabled={disabled}
            style={{ cursor: 'pointer' }}
          />
          {isLoading && (
            <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
              <div className="spinner-small"></div>
            </div>
          )}
        </div>
        <button
          type="button"
          onClick={onAddNew}
          className="btn btn-outline-primary"
          style={{
            padding: '8px 16px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            whiteSpace: 'nowrap'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#218838'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#28a745'}
        >
          <span style={{ fontSize: '18px', fontWeight: 'bold' }}>+</span> New Route
        </button>
      </div>

      {showDropdown && (routes.length > 0 || searchTerm) && (
        <div className="master-route-dropdown" style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: 'white',
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          zIndex: 1000,
          maxHeight: '300px',
          overflowY: 'auto',
          marginTop: '4px'
        }}>
          {routes.length === 0 ? (
            <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}>
              {originCity || destinationCity
                ? `No routes found for ${originCity || ''} → ${destinationCity || ''}. Click + to create one.`
                : 'No routes found. Click + to create one.'}
            </div>
          ) : (
            routes.map((route) => (
              <div
                key={route._id}
                className="dropdown-item"
                onClick={() => handleSelect(route)}
                style={{
                  padding: '10px 12px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #f0f0f0',
                  transition: 'background-color 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
              >
                <div style={{ fontWeight: '500', marginBottom: '4px' }}>
                  {route.routeNumber || ''} - {route.routeName || route.masterRouteName || 'Route'}
                  {route.creatorType === 'BusOwner' && (
                    <span style={{
                      marginLeft: '8px',
                      fontSize: '10px',
                      backgroundColor: '#ffc107',
                      color: '#000',
                      padding: '2px 6px',
                      borderRadius: '4px'
                    }}>
                      Owner
                    </span>
                  )}
                </div>
                <div style={{ fontSize: '12px', color: '#6c757d' }}>
                  {route.origin?.city} → {route.destination?.city} •
                  {route.isRoundTrip ? ' Round Trip' : ' One Way'} •
                  {route.routeDetails?.totalDistance || 0} km
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};
const PlatformFeeConfig = ({ platformFee, onChange }) => {
  return (
    <div className="section-card">
      <h4 className="card-title">
        <span className="title-icon">💰</span>
        Platform Fee Configuration
      </h4>

      <div className="platform-fee-container">
        <div className="form-row">
          <div className="form-group">
            <label className="input-label">Fee Type</label>
            <select
              value={platformFee.type}
              onChange={(e) => onChange({ ...platformFee, type: e.target.value })}
              className="modern-select"
            >
              <option value="fixed">Fixed Amount (₹)</option>
              <option value="percentage">Percentage (%)</option>
            </select>
            <small className="helper-text">
              {platformFee.type === 'fixed' 
                ? 'Charge a fixed amount per booking' 
                : 'Charge a percentage of the fare'}
            </small>
          </div>



          <div className="form-group">
  <label className="input-label">
    {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
  </label>
  <input
    type="number"
    min="0"
    step={platformFee.type === 'fixed' ? "1" : "0.1"}
    value={platformFee.value === 0 ? '' : platformFee.value}
    onChange={(e) => {
      const rawValue = e.target.value;
      const value = rawValue === '' ? 0 : parseFloat(rawValue);
      onChange({ ...platformFee, value: isNaN(value) ? 0 : value });
    }}
    className="modern-input"
    placeholder={platformFee.type === 'fixed' ? "e.g., 50" : "e.g., 5"}
    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
  />
</div>

          <div className="form-group">
            <label className="input-label">Applicable On</label>
            <select
              value={platformFee.applicableOn}
              onChange={(e) => onChange({ ...platformFee, applicableOn: e.target.value })}
              className="modern-select"
            >
              <option value="per_ticket">Per Ticket</option>
              <option value="per_person">Per Person</option>

            </select>

          </div>
        </div>


        {platformFee.value > 0 && (
          <div className="fee-preview">
            <div className="preview-title">Fee Calculation Preview:</div>
            <div className="preview-details">
              <span>
                {platformFee.type === 'fixed' 
                  ? `₹${platformFee.value} ${platformFee.applicableOn === 'per_ticket' ? 'per ticket' : 
                     platformFee.applicableOn === 'per_seat' ? 'per seat' : 'per booking'}`
                  : `${platformFee.value}% of fare ${platformFee.applicableOn === 'per_ticket' ? 'per ticket' : 
                     platformFee.applicableOn === 'per_seat' ? 'per seat' : 'per booking'}`}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
const AddBusModal = ({ ownerId, onClose, onBusAdded }) => {
  const { token } = useSelector(state => state.user);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('basic');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
  const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
  const [blockedSeats, setBlockedSeats] = useState([]);
  const [cancellationTime, setCancellationTime] = useState({
  hours: 1,
  minutes: 0
});

const [seatModes, setSeatModes] = useState({});
const [sleeperPairs, setSleeperPairs] = useState({});

const [ticketBookingType, setTicketBookingType] = useState({
  instantTicket: false,
  seatBooking: false,
  both: false
});

   const [platformFee, setPlatformFee] = useState({
    type: 'fixed',
    value: 0,
    applicableOn: 'per_ticket'
  });

  const [bookingClosedBefore, setBookingClosedBefore] = useState({
    hours: 1,
    minutes: 0
  });

  const [form, setForm] = useState({
    busNumber: '',
    busName: '',
    busType: 'Non-AC',
    busCategory: 'Seater',
    amenities: []
  });

  const [tripType, setTripType] = useState('oneWay');
  const [activeMatrixTab, setActiveMatrixTab] = useState('up');

  const [sourceCity, setSourceCity] = useState('');
  const [destinationCity, setDestinationCity] = useState('');
  const [availableRoutes, setAvailableRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [loadingRoutes, setLoadingRoutes] = useState(false);
  const [showRouteDropdown, setShowRouteDropdown] = useState(false);
  const [routeSearchTerm, setRouteSearchTerm] = useState('');

  const [layoutTemplates, setLayoutTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [activeSeats, setActiveSeats] = useState([]);
  const [customSeatLabels, setCustomSeatLabels] = useState({});
  const [showLayoutModal, setShowLayoutModal] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [loadingLayouts, setLoadingLayouts] = useState(false);
  const [editingSeat, setEditingSeat] = useState(null);
  const [tempSeatLabel, setTempSeatLabel] = useState('');

  const [pricing, setPricing] = useState({
    basePrice: '',
    baseDistance: '',
    costPerKm: ''
  });

  const [fareMatrixUp, setFareMatrixUp] = useState([]);
  const [fareMatrixDown, setFareMatrixDown] = useState([]);

  const [operatingDays, setOperatingDays] = useState([
    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
  ]);

  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
const [localRouteNameSearch, setLocalRouteNameSearch] = useState('');
const [localRouteSearchLoading, setLocalRouteSearchLoading] = useState(false);

  const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
  const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
  const AMENITIES_LIST = [
    'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
    'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
    'GPS Tracking', 'SOS Switch'
  ];
  const DAYS_OF_WEEK = [
    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
  ];
const handleTicketBookingTypeChange = (type) => {
  setTicketBookingType(prev => {
    let newState;
    if (type === 'instantTicket') {
      newState = { 
        ...prev, 
        instantTicket: !prev.instantTicket,
        both: false
      };
      if (!newState.instantTicket && !prev.seatBooking) {
        newState.both = false;
      }
      if (newState.instantTicket && prev.seatBooking) {
        newState.both = true;
      }
      return newState;
    } else if (type === 'seatBooking') {
      newState = { 
        ...prev, 
        seatBooking: !prev.seatBooking,
        both: false
      };
      if (prev.instantTicket && !prev.seatBooking) {
        newState.both = false;
      }
      if (prev.instantTicket && newState.seatBooking) {
        newState.both = true;
      }
      return newState;
    }
    return prev;
  });
};
const handleCancellationTimeChange = (field, value) => {
  setCancellationTime(prev => ({
    ...prev,
    [field]: parseInt(value) || 0
  }));
};

const validateCancellationTime = () => {
  const totalMinutes = (cancellationTime.hours * 60) + cancellationTime.minutes;
  if (totalMinutes < 0) {
    toast.error('Cancellation time cannot be negative');
    return false;
  }
  if (cancellationTime.hours > 48) {
    toast.error('Cancellation hours cannot exceed 48');
    return false;
  }
  if (cancellationTime.minutes > 59) {
    toast.error('Minutes cannot exceed 59');
    return false;
  }
  
  const bookingMinutes = (bookingClosedBefore.hours * 60) + bookingClosedBefore.minutes;
  if (totalMinutes >= bookingMinutes) {
    toast.warning('Cancellation time should be less than booking cut-off time for practical purposes');
  }
  return true;
};

const fetchRoutesByLocalName = async (localName) => {
  if (!localName || !localName.trim()) {
    setAvailableRoutes([]);
    return;
  }

  setLocalRouteSearchLoading(true);
  setLoadingRoutes(true);
  try {
    const response = await getAllBusownerAdminRoutes(
      token,
      1,
      50,
      '',   "",   {},   localName.trim()
    );

    if (response && response.success && response.routes) {
      setAvailableRoutes(response.routes);
    } else {
      setAvailableRoutes([]);
    }
  } catch (error) {
    console.error('Error fetching routes by local name:', error);
    toast.error('Failed to fetch routes');
    setAvailableRoutes([]);
  } finally {
    setLocalRouteSearchLoading(false);
    setLoadingRoutes(false);
  }
};

  const fetchRoutesBySourceDestination = async () => {
    if (!sourceCity || !destinationCity) {
      setAvailableRoutes([]);
      return;
    }

    setLoadingRoutes(true);
    try {
      const response = await getAllBusownerAdminRoutes(
        token,
        1,
        50,
        '',
        '',
        { originCity: sourceCity, destinationCity: destinationCity }
      );
      
      if (response && response.success && response.routes) {
        setAvailableRoutes(response.routes);
      } else {
        setAvailableRoutes([]);
      }
    } catch (error) {
      console.error('Error fetching routes:', error);
      toast.error('Failed to fetch routes');
      setAvailableRoutes([]);
    } finally {
      setLoadingRoutes(false);
    }
  };
useEffect(() => {
  const timer = setTimeout(() => {
    if (localRouteNameSearch.trim()) {
      fetchRoutesByLocalName(localRouteNameSearch);
    }
  }, 500);
  return () => clearTimeout(timer);
}, [localRouteNameSearch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (sourceCity && destinationCity) {
        fetchRoutesBySourceDestination();
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [sourceCity, destinationCity]);

  const filteredRoutes = availableRoutes.filter(route => route.routeName?.toLowerCase().includes(routeSearchTerm.toLowerCase()) ||
  route.routeNumber?.toLowerCase().includes(routeSearchTerm.toLowerCase()) ||
route.localRouteName?.toLowerCase().includes(routeSearchTerm.toLowerCase())
  );

  const handleSelectRoute = (route) => {
    setSelectedRoute(route);
    setShowRouteDropdown(false);
    setRouteSearchTerm('');
    setFareMatrixUp([]);
    setFareMatrixDown([]);
  };

  useEffect(() => {
    const savedData = localStorage.getItem('pendingBusFormData');
    if (savedData) {
      const formData = JSON.parse(savedData);
      if (window.confirm('You have unsaved bus data. Would you like to restore it?')) {
        setForm(prev => ({
          ...prev,
          busNumber: formData.busNumber || '',
          busName: formData.busName || '',
          busType: formData.busType || 'AC',
          busCategory: formData.busCategory || 'Seater',
          amenities: formData.amenities || []
        }));
        setTripType(formData.tripType || 'oneWay');
        setPricing(formData.pricing || { basePrice: '', baseDistance: '', costPerKm: '' });
        setOperatingDays(formData.operatingDays || DAYS_OF_WEEK);
        if (formData.bookingClosedBefore) {
          setBookingClosedBefore(formData.bookingClosedBefore);
        }
        setSelectedConfiguration(formData.selectedConfiguration || '2*2');
        localStorage.removeItem('pendingBusFormData');
      } else {
        localStorage.removeItem('pendingBusFormData');
      }
    }
  }, []);

  const handleAddNewRoute = () => {
    const currentFormData = {
      busNumber: form.busNumber,
      busName: form.busName,
      busType: form.busType,
      busCategory: form.busCategory,
      amenities: form.amenities,
      tripType: tripType,
      pricing: pricing,
      operatingDays: operatingDays,
      bookingClosedBefore: bookingClosedBefore,
      selectedConfiguration: selectedConfiguration,
    };
    localStorage.setItem('pendingBusFormData', JSON.stringify(currentFormData));

    toast.info('Redirecting to create route. Your current bus form data has been saved.');

    navigate('/routes', {
      state: {
        returnTo: 'busowners',
        ownerId: ownerId,
        formData: currentFormData,
        sourceCity: sourceCity,
        destinationCity: destinationCity
      }
    });
  };

  const validateBookingTime = () => {
    const totalMinutes = (bookingClosedBefore.hours * 60) + bookingClosedBefore.minutes;
    if (totalMinutes < 0) {
      toast.error('Booking close time cannot be negative');
      return false;
    }
    if (bookingClosedBefore.hours > 24) {
      toast.error('Booking close hours cannot exceed 24');
      return false;
    }
    if (bookingClosedBefore.minutes > 59) {
      toast.error('Minutes cannot exceed 59');
      return false;
    }
    return true;
  };

  const handleBookingTimeChange = (field, value) => {
    setBookingClosedBefore(prev => ({
      ...prev,
      [field]: parseInt(value) || 0
    }));
  };

  useEffect(() => {
    if (form.busCategory) {
      fetchAvailableConfigurations();
    }
  }, [form.busCategory, token]);

  const getCategoryMultiplier = () => {
    const multipliers = {
      'Seater': 1.0,
      'Sleeper': 1.5,
      'Seater+Sleeper': 1.3
    };
    return multipliers[form.busCategory] || 1.0;
  };

  const getStopColor = (type) => {
    switch (type) {
      case 'origin': return '#4c51bf';
      case 'destination': return '#40c057';
      default: return '#667eea';
    }
  };

  const fetchAvailableConfigurations = async () => {
    try {
      setLoadingLayouts(true);
      const response = await getAllCategory(token);

      if (response && response.success && response.data) {
        let relevantCategories = response.data;

        if (form.busCategory === 'Seater') {
          relevantCategories = response.data.filter(cat =>
            cat.availableSeatTypes?.includes('seat') ||
            cat.availableSeatTypes?.includes('seater')
          );
        } else if (form.busCategory === 'Sleeper') {
          relevantCategories = response.data.filter(cat =>
            cat.availableSeatTypes?.includes('sleeper')
          );
        } else if (form.busCategory === 'Seater+Sleeper') {
          relevantCategories = response.data.filter(cat =>
            cat.availableSeatTypes?.includes('seater+sleeper') ||
            cat.availableSeatTypes?.includes('seat+sleeper')
          );
        }

        const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];

        if (configs.length > 0) {
          setAvailableConfigurations(configs);
          setSelectedConfiguration(configs[0]);
          setLayoutTemplates([]);
        } else {
          setAvailableConfigurations([]);
          setLayoutTemplates([]);
          toast.info(`No configurations available for ${form.busCategory}`);
        }
      }
    } catch (error) {
      console.error('Error fetching configurations:', error);
      setAvailableConfigurations([]);
    } finally {
      setLoadingLayouts(false);
    }
  };

  const fetchLayouts = async (config) => {
    try {
      if (!config) return;

      setLoadingLayouts(true);

      let bustype = config.replace('x', '*');

      const response = await getSeatLayoutsByBustype(bustype, token);

      if (response && response.success) {
        if (response.data && Array.isArray(response.data)) {
          let filteredLayouts = response.data;

          if (form.busCategory === 'Seater') {
            filteredLayouts = response.data.filter(layout =>
              layout.seatType === 'seat' || layout.seatType === 'seater'
            );
          } else if (form.busCategory === 'Sleeper') {
            filteredLayouts = response.data.filter(layout =>
              layout.seatType === 'sleeper'
            );
          } else if (form.busCategory === 'Seater+Sleeper') {
            filteredLayouts = response.data.filter(layout =>
              layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper'
            );
          }

          setLayoutTemplates(filteredLayouts);

          if (filteredLayouts.length === 0) {
            toast.info(`No ${form.busCategory} layouts found for ${config} configuration`);
          }
        } else {
          setLayoutTemplates([]);
          toast.info(`No layouts found for ${config} configuration`);
        }
      } else {
        console.error('Failed to fetch layouts:', response);
        setLayoutTemplates([]);
        toast.error(response?.message || 'Failed to load seat layouts');
      }
    } catch (error) {
      console.error("Layout Fetch Error:", error);
      toast.error('Failed to load seat layouts: ' + (error.message || 'Unknown error'));
      setLayoutTemplates([]);
    } finally {
      setLoadingLayouts(false);
    }
  };

  const handleCategoryChange = (category) => {
    setForm(prev => ({ ...prev, busCategory: category }));
    setSelectedTemplate(null);
    setActiveSeats([]);
    setLayoutTemplates([]);
    setCustomSeatLabels({});
  };

  const handleImageUpload = (event) => {
  const files = Array.from(event.target.files);
  console.log('📸 Files selected for upload:', files.length);
  
  const newImages = [];

  files.forEach((file, index) => {
    console.log(`File ${index + 1}: ${file.name} (${file.size} bytes, ${file.type})`);
    
    if (!(file instanceof File)) {
      console.error(`❌ File ${index + 1} is not a File object`);
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      newImages.push({
        file: file,
        preview: e.target.result,
        name: file.name,
        size: file.size,
        type: file.type
      });

      if (newImages.length === files.length) {
        setSelectedImages(prev => [...prev, ...newImages]);
        console.log(`✅ Added ${newImages.length} images. Total: ${selectedImages.length + newImages.length}`);
      }
    };
    reader.onerror = (error) => {
      console.error('❌ Error reading file:', error);
    };
    reader.readAsDataURL(file);
  });
};

  const removeImage = (index) => {
    setSelectedImages(prev => prev.filter((_, i) => i !== index));
  };

  const handleVideoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedVideo({
          file: file,
          preview: e.target.result,
          name: file.name,
          size: file.size
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const removeVideo = () => {
    setSelectedVideo(null);
  };

  const openTemplateSelector = () => {
    if (!form.busCategory) {
      toast.error('Please select a Bus Category first');
      return;
    }
    if (!selectedConfiguration) {
      toast.error('Please select a Bus Configuration first');
      return;
    }
    if (layoutTemplates.length === 0) {
      toast.error(`No layouts available for ${selectedConfiguration}. Please try a different configuration.`);
      return;
    }
    setShowTemplateModal(true);
  };

const handleSelectTemplate = (template) => {
  setSelectedTemplate(template);
  setActiveSeats([]);
  setBlockedSeats([]);
  setCustomSeatLabels({});
  setSeatModes({});
  setSleeperPairs({});
  setShowTemplateModal(false);
  setShowLayoutModal(true);
  toast.success(`Selected template: ${template.name}`);
};

  const handleSeatPress = (seatObj) => {
    setEditingSeat(seatObj.seatNumber);
    if (activeSeats.includes(seatObj.seatNumber)) {
      setTempSeatLabel(String(customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber));
    } else {
      setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
    }
  };

const autoRenumberSeats = () => {
  const consumed = new Set(Object.values(sleeperPairs));
  const sortedSeats = [...(selectedTemplate.seats || [])].sort((a, b) => {
    if (a.row === b.row) return a.column - b.column;
    return a.row - b.row;
  });

  let counter = 1;
  const newLabels = {};
  sortedSeats.forEach(s => {
    if (activeSeats.includes(s.seatNumber) && !consumed.has(s.seatNumber)) {
      newLabels[s.seatNumber] = String(counter++);
    }
  });
  setCustomSeatLabels(newLabels);
};

  const toggleDay = (day) => {
    setOperatingDays(prev =>
      prev.includes(day)
        ? prev.filter(d => d !== day)
        : [...prev, day]
    );
  };

const generateMatrixForRoute = (routeData) => {
  if (!routeData) return [];

  const baseP = parseFloat(pricing.basePrice) || 0;
  const baseD = parseFloat(pricing.baseDistance) || 0;
  const costK = parseFloat(pricing.costPerKm) || 0;
  const multiplier = getCategoryMultiplier();

  const toSafeDistance = (val) => Math.round(parseFloat(val || 0) * 10) / 10;

  const sortedStops = [...(routeData.intermediateStops || [])]
    .sort((a, b) => a.sequence - b.sequence);

  const rawStops = [
    {
      id: 'origin',
      name: routeData.origin?.city || 'Origin',
      rawDist: toSafeDistance(routeData.origin?.distanceFromOrigin || 0),
      type: 'origin'
    },
    ...sortedStops.map((s, i) => ({
      id: s._id || `stop_${i}`,
      name: s.city || s.name || `Stop ${i + 1}`,
      rawDist: toSafeDistance(s.distanceFromOrigin),
      type: 'stop',
      sequence: s.sequence
    })),
    {
      id: 'destination',
      name: routeData.destination?.city || 'Destination',
      rawDist: toSafeDistance(
        routeData.destination?.distanceFromOrigin ||
        routeData.routeDetails?.totalDistance ||
        0
      ),
      type: 'destination'
    }
  ];

  const allRawDists = rawStops.map(s => s.rawDist);
  const minDist = Math.min(...allRawDists);
  const maxDist = Math.max(...allRawDists);

  const originRaw = rawStops[0].rawDist;
  const destRaw   = rawStops[rawStops.length - 1].rawDist;
  const isDescending = destRaw < originRaw;

  const normalizedStops = rawStops.map(stop => ({
    ...stop,
    distanceFromOrigin: isDescending
      ? toSafeDistance(maxDist - stop.rawDist)
      : toSafeDistance(stop.rawDist - minDist)
  }));

  const allStops = normalizedStops.sort(
    (a, b) => a.distanceFromOrigin - b.distanceFromOrigin
  );

  const matrix = allStops.map((fromStop, i) => {
    const toCells = allStops.map((toStop, j) => {
      if (j > i) {
        const fromInt  = Math.round(fromStop.distanceFromOrigin * 10);
        const toInt    = Math.round(toStop.distanceFromOrigin * 10);
        const distance = Math.abs((toInt - fromInt) / 10);

        let price = baseP;
        if (distance > baseD) {
          const extraDistance = Math.round((distance - baseD) * 10) / 10;
          price = baseP + (extraDistance * costK);
        }
        price = Math.round(price * multiplier);

        return {
          toId: toStop.id,
          toName: toStop.name,
          distanceKm: distance,
          price: price
        };
      }
      return null;
    });

    return {
      fromId: fromStop.id,
      fromName: fromStop.name,
      fromType: fromStop.type,
      sequence: fromStop.sequence,
      toCells: toCells
    };
  });

  return matrix.filter(row => row.fromId !== 'destination');
};

  const handleGenerateMatrix = () => {
    if (!selectedRoute) {
      toast.error('Please select a Route first.');
      return;
    }

    if (tripType === 'roundTrip' && !selectedRoute.returnJourney) {
      toast.error("The selected route does not have return journey details configured.");
      return;
    }

    if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
      toast.error('Please fill all Pricing Fields.');
      return;
    }

    const matrixUp = generateMatrixForRoute(selectedRoute);
    setFareMatrixUp(matrixUp);

    if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
      const matrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
      setFareMatrixDown(matrixDown);
    } else {
      setFareMatrixDown([]);
    }

    toast.success(tripType === 'roundTrip'
      ? "Both Fare Matrices Generated!"
      : "Fare Matrix Generated!"
    );
  };

  const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
    const isUp = type === 'up';
    const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];

    const updatedMatrix = currentMatrix.map((row, rIndex) => {
      if (rIndex !== rowIndex) return row;
      const newToCells = [...row.toCells];
      if (newToCells[colIndex]) {
        newToCells[colIndex] = {
          ...newToCells[colIndex],
          price: parseInt(newPrice) || 0
        };
      }
      return { ...row, toCells: newToCells };
    });

    if (isUp) {
      setFareMatrixUp(updatedMatrix);
    } else {
      setFareMatrixDown(updatedMatrix);
    }
  };

  const getSideCounts = () => {
  let leftCount = 2, rightCount = 2;
  try {
    if (selectedTemplate?.configuration?.includes('*')) {
      const parts = selectedTemplate.configuration.split('*');
      leftCount = parseInt(parts[0]) || 2;
      rightCount = parseInt(parts[1]) || 2;
    }
  } catch (e) { leftCount = 2; rightCount = 2; }
  return { leftCount, rightCount };
};

const isSleeperEligible = () => {
  if (form.busCategory !== 'Seater+Sleeper') return false;
  const { leftCount, rightCount } = getSideCounts();
  return leftCount >= 2 || rightCount >= 2;
};

const getSeatSide = (seat) => {
  const { leftCount } = getSideCounts();
  return (seat.column || 0) <= leftCount ? 'left' : 'right';
};

const findSleeperPartner = (seat) => {
  if (!selectedTemplate) return null;
  const side = getSeatSide(seat);
  const consumed = new Set(Object.values(sleeperPairs));
  const sameRow = selectedTemplate.seats.filter(
    s => s.row === seat.row && getSeatSide(s) === side
  );

  const isUsable = (s) =>
    s.seatNumber !== seat.seatNumber &&
    !consumed.has(s.seatNumber) &&
    !seatModes[s.seatNumber] &&
    !blockedSeats.includes(s.seatNumber);

  const next = sameRow.find(s => s.column === (seat.column || 0) + 1);
  if (next && isUsable(next)) return next;

  const prev = sameRow.find(s => s.column === (seat.column || 0) - 1);
  if (prev && isUsable(prev)) return prev;

  return null;
};

  const getSeatPosition = (column) => {
    switch (parseInt(column)) {
      case 1: return 'window';
      case 2: return 'middle';
      case 3: return 'aisle';
      case 4: return 'window';
      default: return 'aisle';
    }
  };

  const handleToggleSleeper = (seatObj) => {
  const isCurrentlySleeper = seatModes[seatObj.seatNumber] === 'sleeper';

  if (isCurrentlySleeper) {
    const partnerSeatNumber = sleeperPairs[seatObj.seatNumber];
    setSeatModes(prev => { const n = { ...prev }; delete n[seatObj.seatNumber]; return n; });
    setSleeperPairs(prev => { const n = { ...prev }; delete n[seatObj.seatNumber]; return n; });
    if (partnerSeatNumber) {
      setActiveSeats(prev => prev.filter(s => s !== partnerSeatNumber));
    }
  } else {
    const partner = findSleeperPartner(seatObj);
    if (!partner) {
      toast.error('No adjacent seat available to merge into a sleeper on this side.');
      return;
    }
    setSeatModes(prev => ({ ...prev, [seatObj.seatNumber]: 'sleeper' }));
    setSleeperPairs(prev => ({ ...prev, [seatObj.seatNumber]: partner.seatNumber }));
    if (!activeSeats.includes(seatObj.seatNumber)) {
      setActiveSeats(prev => [...prev, seatObj.seatNumber]);
    }
    if (!activeSeats.includes(partner.seatNumber)) {
      setActiveSeats(prev => [...prev, partner.seatNumber]);
    }
  }
};

const handleSubmitBus = async () => {
  try {
    setIsSubmitting(true);
    setError(null);

    console.log('=== SUBMIT BUS DEBUG ===');
    console.log('Selected images count:', selectedImages.length);
    console.log('Selected video:', selectedVideo ? selectedVideo.name : 'None');
    
    if (selectedImages.length > 0) {
      selectedImages.forEach((img, i) => {
        console.log(`Image ${i + 1}:`, img.file ? `${img.file.name} (${img.file.size} bytes, ${img.file.type})` : 'No file object');
      });
    }

    if (!validateBookingTime()) {
      setIsSubmitting(false);
      return;
    }

    if (!validateCancellationTime()) {
      setIsSubmitting(false);
      return;
    }

    if (!ticketBookingType.instantTicket && !ticketBookingType.seatBooking) {
      toast.error('Please select at least one booking option (Instant Ticket or Seat Booking)');
      setIsSubmitting(false);
      return;
    }

    if (!form.busNumber) throw new Error('Bus Number is required');
    if (!form.busName) throw new Error('Bus Name is required');
    if (!form.busType) throw new Error('Bus Type is required');
    if (!form.busCategory) throw new Error('Bus Category is required');
    if (!selectedRoute) throw new Error('Please select a route');
    if (operatingDays.length === 0) throw new Error('Please select at least one operating day');
    if (!selectedTemplate) throw new Error('Please configure seat layout');
    if (fareMatrixUp.length === 0)
      throw new Error('Please generate Fare Matrix');

    if (selectedImages.length === 0) {
      toast.warning('No images selected. It\'s recommended to add bus images.');
    }

    const amenitiesArray = form.amenities || [];
const consumedSeatSet = new Set(Object.values(sleeperPairs));

const bookableSeatsInOrder = selectedTemplate.seats
  .filter(s => activeSeats.includes(s.seatNumber) && !consumedSeatSet.has(s.seatNumber))
  .sort((a, b) => {
    if (a.row !== b.row) return a.row - b.row;
    return (a.column || 0) - (b.column || 0);
  });

const seatPrefixMatch = (selectedTemplate.seats[0]?.seatNumber || 'S').match(/^[A-Za-z]+/);
const seatPrefix = seatPrefixMatch ? seatPrefixMatch[0] : 'S';

const finalSeatsPayload = bookableSeatsInOrder.map((s, idx) => {
  const sequentialSeatNumber = `${seatPrefix}${idx + 1}`;

  const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
  const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
  const isBlocked = blockedSeats.includes(s.seatNumber);
  const isMergedSleeper = seatModes[s.seatNumber] === 'sleeper';

return {
  seatNumber: sequentialSeatNumber,
  globalSeatIndex: finalGlobalIndex,
  row: s.row,
  column: s.column,
  seatType: isMergedSleeper ? 'sleeper' : 'seater',
  position: s.position || getSeatPosition(s.column),
  isBlocked: isBlocked,
  isAvailable: !isBlocked,
  ...(isMergedSleeper ? { seatSpan: 2 } : {})
};
});

const bookableSeatCount = bookableSeatsInOrder.length;

const seatConfigPayload = {
  busType: selectedTemplate.configuration || '2*2',
  totalSeats: bookableSeatCount
};

    const routeSchedules = [];
    const routeIdToSave = selectedRoute._id || selectedRoute.id;

    routeSchedules.push({
      routeId: routeIdToSave,
      direction: 'UP',
      fareMatrix: fareMatrixUp,
      operatingDays: operatingDays,
      departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
      arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
    });

    if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
      routeSchedules.push({
        routeId: routeIdToSave,
        direction: 'DOWN',
        fareMatrix: fareMatrixDown,
        operatingDays: operatingDays,
        departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
        arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
      });
    }

    const fareDetails = {
      basePrice: parseFloat(pricing.basePrice) || 0,
      baseDistance: parseFloat(pricing.baseDistance) || 0,
      costPerKm: parseFloat(pricing.costPerKm) || 0
    };

    const platformFeeData = {
      type: platformFee.type,
      value: platformFee.value,
      applicableOn: platformFee.applicableOn
    };

    const formData = new FormData();

    formData.append('busNumber', form.busNumber.toUpperCase().trim());
    formData.append('busName', form.busName.trim());
    formData.append('busType', form.busType);
    formData.append('busCategory', form.busCategory);
    formData.append('totalSeats', String(bookableSeatCount));
    formData.append('tripType', tripType);
    formData.append('busClass', 'Economy');
    formData.append('cancellationTime', JSON.stringify(cancellationTime));
    formData.append('amenities', JSON.stringify(amenitiesArray));
    formData.append('seats', JSON.stringify(finalSeatsPayload));
    formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
    formData.append('routeSchedules', JSON.stringify(routeSchedules));
    formData.append('fareDetails', JSON.stringify(fareDetails));
    formData.append('operatingDays', JSON.stringify(operatingDays));
    formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
    formData.append('platformFee', JSON.stringify(platformFeeData));
    formData.append('ticketBookingType', JSON.stringify({
      instantTicket: ticketBookingType.instantTicket,
      seatBooking: ticketBookingType.seatBooking,
      both: ticketBookingType.instantTicket && ticketBookingType.seatBooking
    }));

    console.log('📸 Appending images to FormData...');
    let imageAppendedCount = 0;
    
    for (let i = 0; i < selectedImages.length; i++) {
      const img = selectedImages[i];
      if (img.file) {
        if (img.file instanceof File || img.file instanceof Blob) {
          formData.append('images', img.file);
          imageAppendedCount++;
          console.log(`✅ Appended image ${i + 1}: ${img.file.name} (${img.file.size} bytes)`);
        } else {
          console.error(`❌ Image ${i + 1} is not a valid File object:`, img.file);
        }
      }
    }

    console.log(`📸 Total images appended: ${imageAppendedCount}`);

    if (selectedVideo && selectedVideo.file) {
      if (selectedVideo.file instanceof File || selectedVideo.file instanceof Blob) {
        formData.append('videos', selectedVideo.file);
        console.log(`🎬 Appended video: ${selectedVideo.file.name} (${selectedVideo.file.size} bytes)`);
      } else {
        console.error('❌ Video is not a valid File object:', selectedVideo.file);
      }
    }

    console.log('=== FORMDATA ENTRIES ===');
    for (let [key, value] of formData.entries()) {
      if (key === 'images' || key === 'videos') {
        console.log(`${key}: ${value.name} (${value.size} bytes, ${value.type})`);
      } else {
        const stringValue = typeof value === 'string' ? value : String(value);
        console.log(`${key}: ${stringValue.substring(0, 100)}${stringValue.length > 100 ? '...' : ''}`);
      }
    }

    console.log('FormData size:', formData.getAll('images').length, 'images');
    
    const response = await addBusToOwner(ownerId, formData, token);

    console.log('=== RESPONSE ===', response);

    if (response && response.success) {
      toast.success(tripType === 'roundTrip'
        ? 'Bus added successfully with round trip routes!'
        : 'Bus added successfully!'
      );
      onBusAdded();
      onClose();
    } else {
      throw new Error(response?.message || 'Failed to add bus');
    }

  } catch (err) {
    console.error('❌ Error adding bus:', err);
    setError(err.message || 'Failed to add bus');
    toast.error(err.message || 'Failed to add bus');
  } finally {
    setIsSubmitting(false);
  }
};

  const renderMatrix = (type) => {
    const isUp = type === 'up';
    const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
    const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

    if (!currentRoute || currentMatrix.length === 0) return null;

    const sortedStops = [...(currentRoute.intermediateStops || [])]
      .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

    const allStops = [
      { name: currentRoute.origin?.city || 'Origin', type: 'origin' },
      ...sortedStops.map(s => ({ name: s.city || s.name || 'Stop', type: 'stop' })),
      { name: currentRoute.destination?.city || 'Destination', type: 'destination' }
    ];

    return (
      <div className="matrix-section">
        <h5 className="matrix-title">
          {isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}
        </h5>
        <div className="matrix-container">
          <div className="matrix-table-wrapper">
            <table className="fare-matrix-table">
              <thead>
                <tr>
                  <th className="from-cell">From \ To</th>
                  {allStops.map((stop, i) => (
                    <th className="price-cell" key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
                      <div className="stop-header">
                        <span className="stop-name">{stop.name}</span>
                        <span className="stop-type">{stop.type}</span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentMatrix.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td
                      className="from-cell"
                      style={{ backgroundColor: getStopColor(row.fromType) }}
                    >
                      <div className="from-stop">
                        <span className="stop-name">{row.fromName}</span>
                        <span className="stop-type">{row.fromType}</span>
                      </div>
                    </td>
                    {row.toCells.map((cell, colIndex) => {
                      if (cell) {
                        return (
                          <td key={colIndex} className="price-cell">
                            <div className="fare-cell">
                              <span className="distance">{cell.distanceKm} km</span>
                              <div className="price-input-group">
                                <span className="currency">₹</span>
                                <input
                                  type="number"
                                  className="matrix-input"
                                  value={cell.price}
                                  onChange={(e) => handlePriceChange(type, rowIndex, colIndex, e.target.value)}
                                  min="0"
                                  step="1"
                                />
                              </div>
                            </div>
                           </td>
                        );
                      }
                      return <td key={colIndex} className="na-cell">—</td>;
                    })}
                   </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  const renderSeatVisualizer = () => {
    if (!selectedTemplate) return null;

    const { seats, configuration } = selectedTemplate;

    let leftCount = 2, rightCount = 2;
    try {
      if (configuration && configuration.includes('*')) {
        const parts = configuration.split('*');
        leftCount = parseInt(parts[0]) || 2;
        rightCount = parseInt(parts[1]) || 2;
      }
    } catch (e) {
      leftCount = 2;
      rightCount = 2;
    }

    const totalConfigCols = leftCount + rightCount;

    const seatsByRow = {};
    seats.forEach(seat => {
      if (!seatsByRow[seat.row]) {
        seatsByRow[seat.row] = [];
      }
      seatsByRow[seat.row].push(seat);
    });

    const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);

    const rows = [];

const renderSeat = (seatObj) => {
  const consumedSet = new Set(Object.values(sleeperPairs));
  if (consumedSet.has(seatObj.seatNumber))
    return null;

  const isSelected = activeSeats.includes(seatObj.seatNumber);
  const isBlocked = blockedSeats.includes(seatObj.seatNumber);
  const isMergedSleeper = seatModes[seatObj.seatNumber] === 'sleeper';
  const isSleeper = isMergedSleeper ||
    seatObj.seatType === 'sleeper' ||
    seatObj.seatType === 'seat+sleeper' ||
    selectedTemplate.seatType === 'sleeper' ||
    selectedTemplate.seatType === 'seater+sleeper';

  const displayLabel = isSelected
    ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber)
    : "";

  let seatClass = '';
  if (isSelected) seatClass = isBlocked ? 'blocked' : 'selected';
  else seatClass = 'inactive';

  const showSleeperCheckbox = isSleeperEligible() && isSelected && !isBlocked;

  return (
    <div key={seatObj.seatNumber} className="seat-wrapper" style={{ position: 'relative' }}>
      <button
        className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${isMergedSleeper ? 'sleeper-merged' : ''} ${seatClass}`}
        onClick={() => handleSeatPress(seatObj)}
        type="button"
      >
        <span className="seat-number">{displayLabel}</span>
        {isMergedSleeper && <span className="sleeper-tag">Sleeper</span>}
      </button>

      {showSleeperCheckbox && (
        <label
          className="sleeper-checkbox-overlay"
          onClick={(e) => e.stopPropagation()}
          title={isMergedSleeper ? 'Unmark sleeper' : 'Mark as sleeper (merges with adjacent seat)'}
          style={{
            position: 'absolute', top: '-6px', right: '-6px',
            background: '#fff', borderRadius: '50%', width: '16px', height: '16px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 1px 3px rgba(0,0,0,0.3)', cursor: 'pointer'
          }}
        >
          <input
            type="checkbox"
            checked={isMergedSleeper}
            onChange={() => handleToggleSleeper(seatObj)}
            style={{ width: '12px', height: '12px', margin: 0 }}
          />
        </label>
      )}
    </div>
  );
};

    rowNumbers.forEach(rowNum => {
      const seatsInRow = seatsByRow[rowNum];

      const isBackRow = seatsInRow.some(s => s.position === 'back') ||
        seatsInRow.length > totalConfigCols;

      if (isBackRow) {
        const sortedSeats = seatsInRow.sort((a, b) => (a.column || 0) - (b.column || 0));
        rows.push(
          <div key={`row-${rowNum}`} className="seat-row back-row">
            <div className="seats-container">
              {sortedSeats.map(seat => renderSeat(seat)).filter(Boolean)}
            </div>
          </div>
        );
      } else {
        const leftSeats = seatsInRow
          .filter(s => (s.column || 0) <= leftCount)
          .sort((a, b) => (a.column || 0) - (b.column || 0));

        const rightSeats = seatsInRow
          .filter(s => (s.column || 0) > leftCount)
          .sort((a, b) => (a.column || 0) - (b.column || 0));

        rows.push(
          <div key={`row-${rowNum}`} className="seat-row">
            <div className="left-seats">
              {leftSeats.map(seat => renderSeat(seat)).filter(Boolean)}
            </div>
            <div className="aisle">Aisle</div>
            <div className="right-seats">
              {rightSeats.map(seat => renderSeat(seat)).filter(Boolean)}
            </div>
          </div>
        );
      }
    });

    return (
      <div className="seat-layout-visualizer">
        <div className="bus-header">
          <div className="driver-area">Driver</div>
          <div className="bus-info">
            <span className="bus-config">{selectedTemplate.configuration}</span>
            <span className="bus-type">{selectedTemplate.seatType || 'seat'}</span>
          </div>
        </div>
        <div className="bus-body">
          {rows}
        </div>
        <div className="seat-legend">
          <div className="legend-item">
            <div className="seat-sample selected"></div>
            <span>Active Seat ({activeSeats.length})</span>
          </div>
          <div className="legend-item">
            <div className="seat-sample inactive"></div>
            <span>Inactive Seat</span>
          </div>
          <div className="legend-item">
            <div className="seat-sample sleeper"></div>
            <span>Sleeper</span>
          </div>
        </div>
        <div className="seat-summary">
          <strong>Total Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || seats.length}</strong>
        </div>
      </div>
    );
  };

  const ProgressSteps = () => (
    <div className="progress-steps">
      <div className={`step ${activeTab === 'basic' ? 'active' : ''} ${['route', 'matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
        <div className="step-icon">1</div>
        <div className="step-label">Basic Info</div>
      </div>
      <div className="step-connector"></div>
      <div className={`step ${activeTab === 'route' ? 'active' : ''} ${['matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
        <div className="step-icon">2</div>
        <div className="step-label">Route & Pricing</div>
      </div>
      <div className="step-connector"></div>
      <div className={`step ${activeTab === 'matrix' ? 'active' : ''} ${['seats'].includes(activeTab) ? 'completed' : ''}`}>
        <div className="step-icon">3</div>
        <div className="step-label">Fare Matrix</div>
      </div>
      <div className="step-connector"></div>
      <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
        <div className="step-icon">4</div>
        <div className="step-label">Seat Layout</div>
      </div>
    </div>
  );

  const renderBasicInfoTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title">
        <h3>Bus Information</h3>
        <p className="section-subtitle">Enter basic details about the bus</p>
      </div>

      <div className="form-grid">
        <div className="input-group">
          <label className="input-label">
            <span className="label-icon">🚌</span>
            Bus Number *
          </label>
          <input
            type="text"
            value={form.busNumber}
            onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
            placeholder="e.g., WB01AB1234"
            className="modern-input"
            required
          />
        </div>

        <div className="input-group">
          <label className="input-label">
            <span className="label-icon">🏷️</span>
            Bus Name *
          </label>
          <input
            type="text"
            value={form.busName}
            onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
            placeholder="e.g., Volvo Multi-Axle"
            className="modern-input"
            required
          />
        </div>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">🖼️</span>
          Bus Images
        </h4>
        <div className="images-upload-area">
          <input
            type="file"
            id="bus-images"
            multiple
            accept="image/*"
            onChange={handleImageUpload}
            className="image-upload-input"
            style={{ display: 'none' }}
          />
          <label htmlFor="bus-images" className="image-upload-label">
            <span className="upload-icon">📁</span>
            <span className="upload-text">Click to upload images</span>
            <span className="upload-hint">Upload multiple images (max 10)</span>
          </label>

          {selectedImages.length > 0 && (
            <div className="selected-images-preview">
              <h5>Selected Images ({selectedImages.length})</h5>
              <div className="images-grid">
                {selectedImages.map((image, index) => (
                  <div key={index} className="image-preview-item">
                    <img
                      src={image.preview}
                      alt={`Bus ${index + 1}`}
                      className="preview-image"
                    />
                    <button
                      type="button"
                      className="remove-image-btn"
                      onClick={() => removeImage(index)}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}


        </div>
      </div>

<div className="section-card">
  <h4 className="card-title">
    <span className="title-icon">🎫</span>
    Ticket Booking Options
  </h4>
  <div className="booking-type-grid">
    <div className={`booking-type-item ${ticketBookingType.instantTicket ? 'active' : ''}`}>
      <label className="checkbox-label">
        <input
          type="checkbox"
          checked={ticketBookingType.instantTicket}
          onChange={() => handleTicketBookingTypeChange('instantTicket')}
          className="modern-checkbox"
        />
        <span className="checkbox-content">
          <span className="checkbox-icon">⚡</span>
          <span className="checkbox-text">
            <span className="checkbox-title">Instant Ticket</span>
            <span className="checkbox-subtitle">Generate ticket immediately on booking</span>
          </span>
        </span>
      </label>
    </div>
    
    <div className={`booking-type-item ${ticketBookingType.seatBooking ? 'active' : ''}`}>
      <label className="checkbox-label">
        <input
          type="checkbox"
          checked={ticketBookingType.seatBooking}
          onChange={() => handleTicketBookingTypeChange('seatBooking')}
          className="modern-checkbox"
        />
        <span className="checkbox-content">
          <span className="checkbox-icon">💺</span>
          <span className="checkbox-text">
            <span className="checkbox-title">Seat Booking</span>
            <span className="checkbox-subtitle">Reserve seats without immediate ticket</span>
          </span>
        </span>
      </label>
    </div>
    
    {ticketBookingType.instantTicket && ticketBookingType.seatBooking && (
      <div className="booking-type-summary both-selected">
        <span className="badge">✨ Both Enabled</span>
        <span>Passengers can book instantly or reserve seats</span>
      </div>
    )}
    
    {!ticketBookingType.instantTicket && !ticketBookingType.seatBooking && (
      <div className="booking-type-summary none-selected">
        <span className="badge warning">⚠️</span>
        <span>Please select at least one booking option</span>
      </div>
    )}
  </div>
  <small className="helper-text">
    Select one or both booking types. "Both" is automatically enabled when both options are selected.
  </small>
</div>

      <div className="form-row">
        <div className="form-group">
          <label className="input-label">
            <span className="label-icon">🔧</span>
            Bus Type *
          </label>
          <select
            value={form.busType}
            onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
            className="modern-select"
          >
            {BUS_TYPES.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="input-label">
            <span className="label-icon">📊</span>
            Bus Category *
          </label>
          <select
            value={form.busCategory}
            onChange={(e) => handleCategoryChange(e.target.value)}
            className="modern-select"
          >
            <option value="">Select Category</option>
            {BUS_CATEGORIES.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
          <small className="helper-text">Multiplier: {getCategoryMultiplier()}x</small>
        </div>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">⏰</span>
          Booking Cut-off Time
        </h4>
        <div className="booking-time-container">
          <div className="time-input-group">
            <label className="input-label">Hours before departure</label>
            <div className="time-input-wrapper">
              <input
                type="number"
                min="0"
                max="24"
                value={bookingClosedBefore.hours}
                onChange={(e) => handleBookingTimeChange('hours', e.target.value)}
                className="modern-input time-input"
              />
              <span className="time-unit">hours</span>
            </div>
          </div>
          <div className="time-input-group">
            <label className="input-label">Minutes before departure</label>
            <div className="time-input-wrapper">
              <input
                type="number"
                min="0"
                max="59"
                value={bookingClosedBefore.minutes}
                onChange={(e) => handleBookingTimeChange('minutes', e.target.value)}
                className="modern-input time-input"
              />
              <span className="time-unit">minutes</span>
            </div>
          </div>
        </div>
      </div>

<div className="section-card">
  <h4 className="card-title">
    <span className="title-icon">⏰</span>
    Cancellation Time
  </h4>
  <div className="booking-time-container">
    <div className="time-input-group">
      <label className="input-label">Hours before departure</label>
      <div className="time-input-wrapper">
        <input
          type="number"
          min="0"
          max="48"
          value={cancellationTime.hours}
          onChange={(e) => handleCancellationTimeChange('hours', e.target.value)}
          className="modern-input time-input"
        />
        <span className="time-unit">hours</span>
      </div>
    </div>
    <div className="time-input-group">
      <label className="input-label">Minutes before departure</label>
      <div className="time-input-wrapper">
        <input
          type="number"
          min="0"
          max="59"
          value={cancellationTime.minutes}
          onChange={(e) => handleCancellationTimeChange('minutes', e.target.value)}
          className="modern-input time-input"
        />
        <span className="time-unit">minutes</span>
      </div>
    </div>
  </div>
  <small className="helper-text">
    Cancellation allowed up to this time before departure
  </small>
</div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">✨</span>
          Amenities
        </h4>
        <div className="amenities-grid compact">
          {AMENITIES_LIST.map(amenity => (
            <label key={amenity} className="amenity-option compact">
              <input
                type="checkbox"
                checked={form.amenities.includes(amenity)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setForm(prev => ({
                      ...prev,
                      amenities: [...prev.amenities, amenity]
                    }));
                  } else {
                    setForm(prev => ({
                      ...prev,
                      amenities: prev.amenities.filter(a => a !== amenity)
                    }));
                  }
                }}
                className="amenity-checkbox"
              />
              <span className="amenity-content">
                <span className="amenity-icon">✓</span>
                <span className="amenity-label">{amenity}</span>
              </span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-actions">
        <button
          className="modern-btn primary full-width"
          onClick={() => setActiveTab('route')}
          disabled={!form.busNumber || !form.busName || !form.busType || !form.busCategory}
        >
          Continue to Route & Pricing
          <span className="btn-icon">→</span>
        </button>
      </div>
    </div>
  );

  const renderRouteTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title">
        <h3>Route & Pricing Configuration</h3>
        <p className="section-subtitle">Select source, destination and configure pricing for this bus</p>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">🔄</span>
          Trip Type
        </h4>
        <div className="trip-type-container">
          <button
            type="button"
            className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
            onClick={() => setTripType('oneWay')}
          >
            <span className="btn-icon">➡️</span>
            One Way
          </button>
          <button
            type="button"
            className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
            onClick={() => setTripType('roundTrip')}
          >
            <span className="btn-icon">🔄</span>
            Round Trip
          </button>
        </div>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">📍</span>
          Source & Destination
        </h4>
        
        <div className="form-row">
          <div className="form-group">
            <label className="input-label">Source City *</label>
            <input
              type="text"
              value={sourceCity}
              onChange={(e) => {
                setSourceCity(e.target.value);
                setSelectedRoute(null);
              }}
              placeholder="Enter source city"
              className="modern-input"
            />
          </div>

          <div className="form-group">
            <label className="input-label">Destination City *</label>
            <input
              type="text"
              value={destinationCity}
              onChange={(e) => {
                setDestinationCity(e.target.value);
                setSelectedRoute(null);
              }}
              placeholder="Enter destination city"
              className="modern-input"
            />
          </div>


          <div className="form-group" style={{ marginTop: '10px' }}>
            <label className="input-label">— OR — Search by Local Route Name</label>
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                value={localRouteNameSearch}
                onChange={(e) => {
                  const val = e.target.value;
                  setLocalRouteNameSearch(val);
                  setSelectedRoute(null);
                  if (val.trim()) {
                    setSourceCity('');
                    setDestinationCity('');
                  }
                }}
                placeholder="e.g. Panskura to Bagnan local name..."
                className="modern-input"
              />
              {localRouteSearchLoading && (
                <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                  <div className="spinner-small"></div>
                </div>
              )}
            </div>
            <small className="helper-text">
              Search routes directly by local name without entering city filters
            </small>
          </div>
        </div>
      </div>


      {(sourceCity && destinationCity || availableRoutes.length > 0) && (
        <div className="section-card">
          <h4 className="card-title">
            <span className="title-icon">🗺️</span>
            Select Route
          </h4>
          
          <div className="route-selector">
  <label className="input-label">Available Routes *</label>
  <div className="route-dropdown-container">
    <input
      type="text"
      value={selectedRoute ? `${selectedRoute.localRouteName ? `${selectedRoute.localRouteName} - ` : ''}${selectedRoute.routeName}` : routeSearchTerm}
      onClick={() => setShowRouteDropdown(!showRouteDropdown)}
      onChange={(e) => {
        setRouteSearchTerm(e.target.value);
        setShowRouteDropdown(true);
        if (selectedRoute) setSelectedRoute(null);
      }}
      placeholder={loadingRoutes ? "Loading routes..." : "Click to select route"}
      className="modern-input"
      disabled={loadingRoutes}
      style={{ cursor: 'pointer' }}
    />
    {loadingRoutes && (
      <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
        <div className="spinner-small"></div>
      </div>
    )}
    
    {showRouteDropdown && availableRoutes.length > 0 && (
      <div className="route-dropdown">
        <div className="dropdown-search">
          <input
            type="text"
            value={routeSearchTerm}
            onChange={(e) => setRouteSearchTerm(e.target.value)}
            placeholder="Search routes..."
            className="dropdown-search-input"
            autoFocus
          />
        </div>
        <div className="dropdown-list">
          {filteredRoutes.length === 0 ? (
            <div className="dropdown-empty">No matching routes</div>
          ) : (
            filteredRoutes.map((route) => (
              <div
                key={route._id}
                className="dropdown-item"
                onClick={() => handleSelectRoute(route)}
              >
               <div className="route-number">
  {route.localRouteName ? (
    <div className="route-name-stack">
      <div className="local-route-name">{route.localRouteName}</div>
      <div className="route-name">{route.routeName}</div>
    </div>
  ) : (
    <div className="route-name">{route.routeName}</div>
  )}
</div>
                <div className="route-details">
                  {route.origin?.city} → {route.destination?.city} • 
                  {route.isRoundTrip ? ' Round Trip' : ' One Way'} • 
                  {route.routeDetails?.totalDistance || 0} km
                </div>
                {route.creatorType === 'BusOwner' && (
                  <span className="owner-badge">Owner</span>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    )}
  </div>
  
  {availableRoutes.length === 0 && sourceCity && destinationCity && !loadingRoutes && (
    <div className="no-routes-message">
      <p>No routes found for {sourceCity} → {destinationCity}</p>
      <button type="button" onClick={handleAddNewRoute} className="create-route-btn">
        + Create New Route
      </button>
    </div>
  )}
  
  {selectedRoute && selectedRoute.isRoundTrip && (
    <small className="helper-text">✓ Round trip route selected - both UP and DOWN matrices will be generated</small>
  )}
</div>
        </div>
      )}

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">📅</span>
          Operating Days *
        </h4>
        <div className="days-grid compact">
          {DAYS_OF_WEEK.map(day => (
            <button
              key={day}
              type="button"
              className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
              onClick={() => toggleDay(day)}
              title={day}
            >
              {day.substring(0, 3)}
            </button>
          ))}
        </div>
        <div className="selected-days">
          Selected: {operatingDays.length} days
        </div>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">💰</span>
          Pricing Configuration
        </h4>

        <div className="form-row">
          <div className="form-group">
            <label>Base Price (₹) *</label>
            <input
              type="number"
              value={pricing.basePrice}
              onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
              placeholder="e.g., 100"
              className="modern-input"
              min="0"
              step="1"
            />
          </div>
          <div className="form-group">
            <label>Base Distance (km) *</label>
            <input
              type="number"
              value={pricing.baseDistance}
              onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
              placeholder="e.g., 15"
              className="modern-input"
              min="0"
              step="0.1"
            />
          </div>
          <div className="form-group">
            <label>Cost per km (₹) *</label>
            <input
              type="number"
              value={pricing.costPerKm}
              onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
              placeholder="e.g., 4"
              className="modern-input"
              min="0"
              step="0.1"
            />
          </div>
        </div>

        {selectedRoute && (
          <div className="pricing-summary">
            <div className="summary-item">
              <span>Category Multiplier:</span>
              <span className="value accent">{getCategoryMultiplier()}x</span>
            </div>
            <div className="summary-item">
              <span>Route Distance:</span>
              <span className="value">{selectedRoute.routeDetails?.totalDistance || 0} km</span>
            </div>
          </div>
        )}
      </div>

      <PlatformFeeConfig 
     platformFee={platformFee} 
     onChange={setPlatformFee} 
   />

      <div className="form-actions">
        <button
          type="button"
          className="modern-btn outline"
          onClick={() => setActiveTab('basic')}
        >
          ← Back
        </button>
        <button
          type="button"
          className="modern-btn primary generate-matrix-btn"
          onClick={() => {
            handleGenerateMatrix();
            if (fareMatrixUp.length > 0) {
              setActiveTab('matrix');
            }
          }}
          disabled={!selectedRoute || !pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm}
        >
          Generate Fare Matrix
          <span className="btn-icon">→</span>
        </button>
      </div>
    </div>
  );

  const renderMatrixTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title">
        <h3>Fare Matrix Configuration</h3>
        <p className="section-subtitle">Review and edit fares for each route</p>
      </div>

      {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
        <div className="matrix-tabs">
          <button
            type="button"
            className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
            onClick={() => setActiveMatrixTab('up')}
          >
            Up Route: {selectedRoute.routeName}
          </button>
          <button
            type="button"
            className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
            onClick={() => setActiveMatrixTab('down')}
          >
            Down Route: Return Route
          </button>
        </div>
      )}

      {tripType === 'roundTrip' && selectedRoute?.returnJourney ? (
        <>
          {activeMatrixTab === 'up' && renderMatrix('up')}
          {activeMatrixTab === 'down' && renderMatrix('down')}
        </>
      ) : (
        renderMatrix('up')
      )}

      <div className="matrix-info">
        <div className="info-card">
          <div className="info-item">
            <span className="label">Total Stops:</span>
            <span className="value">
              {selectedRoute ?
                (selectedRoute.intermediateStops?.length || 0) + 2 : 0}
            </span>
          </div>
          <div className="info-item">
            <span className="label">Category Multiplier:</span>
            <span className="value accent">{getCategoryMultiplier()}x</span>
          </div>
          <div className="info-item">
            <span className="label">Base Price:</span>
            <span className="value">₹{pricing.basePrice}</span>
          </div>
          <div className="info-item">
            <span className="label">Cost/km:</span>
            <span className="value">₹{pricing.costPerKm}</span>
          </div>
        </div>
      </div>

      <div className="form-actions">
        <button
          type="button"
          className="modern-btn outline"
          onClick={() => setActiveTab('route')}
        >
          ← Back to Pricing
        </button>
        <button
          type="button"
          className="modern-btn primary"
          onClick={() => setActiveTab('seats')}
          disabled={fareMatrixUp.length === 0}
        >
          Continue to Seat Layout
          <span className="btn-icon">→</span>
        </button>
      </div>
    </div>
  );

  const renderSeatLayoutTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title">
        <h3>Seat Layout Configuration</h3>
        <p className="section-subtitle">Configure seat layout for this bus</p>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">🔧</span>
          Bus Configuration
        </h4>
        <div className="config-selector">
          <label className="input-label">Select Bus Configuration *</label>
          {loadingLayouts ? (
            <div className="loading-configs">
              <span>Loading configurations...</span>
            </div>
          ) : (
            <>
              <div className="config-buttons">
                {availableConfigurations.map(config => (
                  <button
                    key={config}
                    type="button"
                    className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
                    onClick={() => {
                      setSelectedConfiguration(config);
                      setSelectedTemplate(null);
                      setActiveSeats([]);
                      setCustomSeatLabels({});
                      fetchLayouts(config);
                    }}
                  >
                    {config}
                  </button>
                ))}
              </div>
              <small className="helper-text">
                {form.busCategory} bus with {selectedConfiguration} configuration
              </small>
            </>
          )}
        </div>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">💺</span>
          Seat Layout Template
        </h4>

        {!selectedTemplate ? (
          <button
            type="button"
            className="modern-btn outline full-width"
            onClick={openTemplateSelector}
            disabled={loadingLayouts}
          >
            {loadingLayouts ? (
              <>
                <span className="btn-icon">⏳</span>
                Loading Layouts...
              </>
            ) : (
              <>
                <span className="btn-icon">📋</span>
                Select Layout Template
              </>
            )}
          </button>
        ) : (
          <div className="selected-template-info">
            <div className="template-details">
              <span className="template-name">{selectedTemplate.name}</span>
              <span className="template-config">{selectedTemplate.configuration}</span>
              <span className="template-seats">{selectedTemplate.totalSeats} seats</span>
              <span className="template-type">{selectedTemplate.seatType || 'seat'}</span>
            </div>
            <button
              type="button"
              className="btn-small"
              onClick={() => {
                setSelectedTemplate(null);
                setActiveSeats([]);
                setCustomSeatLabels({});
              }}
            >
              Change
            </button>
          </div>
        )}
      </div>

      {selectedTemplate && (
        <div className="section-card">
          <h4 className="card-title">
            <span className="title-icon">👁️</span>
            Seat Layout Visualizer
          </h4>
          <button
            type="button"
            className="view-layout-btn"
            onClick={() => setShowLayoutModal(true)}
          >
            View / Edit Seat Numbers
          </button>

          <div className="seat-summary">
            <div className="summary-item">
              <span>Total Seats in Template:</span>
              <span className="value">{selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0}</span>
            </div>
            <div className="summary-item">
              <span>Active Seats:</span>
              <span className="value accent">{activeSeats.length}</span>
            </div>
            <div className="summary-item">
              <span>Inactive Seats:</span>
              <span className="value">{(selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0) - activeSeats.length}</span>
            </div>
          </div>
        </div>
      )}

      <div className="form-actions">
        <button
          type="button"
          className="modern-btn outline"
          onClick={() => setActiveTab('matrix')}
        >
          ← Back to Matrix
        </button>
        <button
          type="button"
          className="modern-btn primary"
          onClick={handleSubmitBus}
          disabled={!selectedTemplate || activeSeats.length === 0 || isSubmitting}
        >
          {isSubmitting ? 'Adding Bus...' : `${tripType === 'roundTrip' ? 'Add Round Trip Bus' : 'Add Bus'}`}
          <span className="btn-icon">✓</span>
        </button>
      </div>
    </div>
  );

  const renderLayoutModal = () => (
    <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
      <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Edit Seat Numbers</h3>
          <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
        </div>
        <div className="modal-body">
          <p className="instruction-text">Tap a seat to enter its number and activate it.</p>
          <div className="seat-legend three-items">
            <div className="legend-item">
              <div className="seat-sample selected"></div>
              <span>Active</span>
            </div>
            <div className="legend-item">
              <div className="seat-sample blocked"></div>
              <span>Blocked</span>
            </div>
            <div className="legend-item">
              <div className="seat-sample inactive"></div>
              <span>Disabled</span>
            </div>
          </div>
          {renderSeatVisualizer()}
          <div className="layout-footer">
            <span>Total: {activeSeats.length}</span>
            <div className="footer-actions">
              <button className="auto-number-btn" onClick={autoRenumberSeats}>
                Auto-Number
              </button>
              <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderTemplateModal = () => (
    <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
      <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Select Seat Layout Template</h3>
          <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
        </div>
        <div className="modal-body">
          {loadingLayouts ? (
            <div className="loading-container">
              <p>Loading templates...</p>
            </div>
          ) : layoutTemplates.length === 0 ? (
            <div className="no-templates">
              <p>No {form.busCategory} layouts found for {selectedConfiguration} configuration</p>
              <p className="hint">Available configurations with layouts:</p>
              <div className="available-configs">
                {availableConfigurations.map(config => (
                  <span key={config} className="config-chip">{config}</span>
                ))}
              </div>
              <p className="hint">Try selecting a different configuration</p>
            </div>
          ) : (
            <div className="templates-grid">
              {layoutTemplates.map(template => (
                <button
                  type="button"
                  key={template._id}
                  className="template-card"
                  onClick={() => handleSelectTemplate(template)}
                >
                  <h4 className="template-name">{template.name}</h4>
                  <div className="template-details">
                    <span className="config">Config: {template.configuration}</span>
                    <span className="seats">Seats: {template.totalSeats}</span>
                  </div>
                  <div className="template-preview">
                    <span className="rows">Rows: {template.rows}</span>
                    <span className="cols">Cols: {template.columns}</span>
                    <span className="seat-type">Type: {template.seatType || 'seat'}</span>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );

const renderSeatEditModal = () => {
    const seatObj = selectedTemplate?.seats?.find(s => s.seatNumber === editingSeat);
    const isMergedSleeper = seatModes[editingSeat] === 'sleeper';
    const canOfferSleeper = seatObj && isSleeperEligible() && (isMergedSleeper || findSleeperPartner(seatObj));

    return (
      <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
        <div className="modal-content seat-edit-modal" style={{    "max-width": "500px",
      "max-height": "35vh"}} onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Set Seat Label</h3>
          </div>
          <div className="modal-body">
            <input
              type="text"
              value={tempSeatLabel}
              onChange={(e) => setTempSeatLabel(e.target.value)}
              placeholder="e.g. 1 or 1A"
              className="seat-input"
              autoFocus
            />

            {canOfferSleeper && (
              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginTop: '12px',
                  fontSize: '13px',
                  cursor: 'pointer'
                }}
              >
                <input
                  type="checkbox"
                  checked={isMergedSleeper}
                  onChange={() => handleToggleSleeper(seatObj)}
                />
                Mark as Sleeper (merges with adjacent seat)
              </label>
            )}
          </div>
          <div className="modal-footer three-buttons">
            <button
              className="modal-action-btn active-btn"
              onClick={() => {
                if (tempSeatLabel.trim() === '') {
                  toast.error('Please enter a valid seat number');
                  return;
                }
                if (!activeSeats.includes(editingSeat)) {
                  setActiveSeats([...activeSeats, editingSeat]);
                }
                setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
                setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
                setEditingSeat(null);
              }}
            >
              Active
            </button>

            <button
              className="modal-action-btn block-btn"
              onClick={() => {
                if (tempSeatLabel.trim() === '') {
                  toast.error('Please enter a valid seat number');
                  return;
                }
                if (!activeSeats.includes(editingSeat)) {
                  setActiveSeats([...activeSeats, editingSeat]);
                }
                if (!blockedSeats.includes(editingSeat)) {
                  setBlockedSeats([...blockedSeats, editingSeat]);
                }
                setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
                setEditingSeat(null);
              }}
            >
              Block
            </button>
            <button
              className="modal-action-btn disable-btn"
              onClick={() => {
                const partnerSeatNumber = sleeperPairs[editingSeat];
                if (partnerSeatNumber) {
                  setSeatModes(prev => {
                    const n = { ...prev };
                    delete n[editingSeat];
                    return n;
                  });
                  setSleeperPairs(prev => {
                    const n = { ...prev };
                    delete n[editingSeat];
                    return n;
                  });
                  setActiveSeats(prev => prev.filter(s => s !== partnerSeatNumber));
                }
                setActiveSeats(activeSeats.filter(s => s !== editingSeat));
                setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
                setEditingSeat(null);
              }}
            >
              Disable
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="modal-overlay modern" onClick={onClose}>
      <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header modern">
          <div className="header-content">
            <h2 className="modal-title">
              <span className="title-icon">🚌</span>
              Add New Bus {tripType === 'roundTrip' ? '(Round Trip)' : ''}
            </h2>
            <p className="modal-subtitle">Configure bus details with route selection</p>
          </div>
          <button className="modal-close-btn modern" onClick={onClose}>
            <span className="close-icon">×</span>
          </button>
        </div>

        <div className="modal-body modern">
          <ProgressSteps />

          <div className="tab-container">
            {activeTab === 'basic' && renderBasicInfoTab()}
            {activeTab === 'route' && renderRouteTab()}
            {activeTab === 'matrix' && renderMatrixTab()}
            {activeTab === 'seats' && renderSeatLayoutTab()}
          </div>

          {error && (
            <div className="error-message modern">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}
        </div>
      </div>

      {showLayoutModal && renderLayoutModal()}
      {showTemplateModal && renderTemplateModal()}
      {editingSeat && renderSeatEditModal()}
    </div>
  );
};

const BusOwnerManage = () => {
  const { token } = useSelector(state => state.user);
  const [busOwners, setBusOwners] = useState([]);
  const [searching, setSearching] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingOwner, setEditingOwner] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [viewingOwner, setViewingOwner] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showAddBusModal, setShowAddBusModal] = useState(false);
  const [selectedOwnerForBus, setSelectedOwnerForBus] = useState(null);
  const [busSearchTerm, setBusSearchTerm] = useState('');
  const [newOwner, setNewOwner] = useState({
    name: '',
    email: '',
    phone: '',
    companyName: ''
  });
  const [error, setError] = useState(null);
  const [busUpdateTrigger, setBusUpdateTrigger] = useState(0);

  const [viewMode, setViewMode] = useState('regular');
  const [pendingOwners, setPendingOwners] = useState([]);
  const [loadingPending, setLoadingPending] = useState(false);

  const [showBusManagement, setShowBusManagement] = useState(false);
  const [selectedOwnerBuses, setSelectedOwnerBuses] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [busDetailsLoading, setBusDetailsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalOwners, setTotalOwners] = useState(0);
  const [pageSize] = useState(10);
const [seatModes, setSeatModes] = useState({});
const [sleeperPairs, setSleeperPairs] = useState({});

const [isEditingPending, setIsEditingPending] = useState(false);

const handleEditPendingOwner = async (ownerId) => {
  try {
    setError(null);
    setIsEditingPending(true);
    setEditingOwner(ownerId);

    const response = await getPendingBusOwnerById(ownerId, token);

    if (response.success) {
      const owner = response.data;
      setEditForm({
        name: owner.name || '',
        companyName: owner.companyName || '',
        email: owner.email || '',
        phone: owner.phone || '',
        status: owner.status || 'Pending',
        isApprovedByAdmin: false,
        isPending: true
      });
    } else {
      setError('Failed to fetch pending bus owner details for editing.');
      toast.error('Failed to fetch pending bus owner details.');
    }
  } catch (err) {
    console.error('Error fetching pending bus owner details for editing:', err);
    setError('Failed to fetch pending bus owner details for editing.');
    toast.error('Failed to fetch pending bus owner details.');
  }
};

  const getSequentialNumber = (index) => {
    return (currentPage - 1) * pageSize + index + 1;
  };

  const getFullImageUrl = (imagePath) => {
    if (!imagePath) return '';
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    return `${process.env.REACT_APP_BASE_URL}/uploads/${imagePath}`;
  };

  const fetchBusOwners = async () => {
    try {
      setSearching(true);
      setLoading(true);
      setError(null);

      const response = await getBusOwners(token, currentPage, pageSize, searchTerm);
console.log("getBusOwners response : ",response)
      if (response && response.success && response.busOwners) {
        const transformedOwners = response.busOwners.map((owner, index) => ({
          id: owner._id,
          serialNo: getSequentialNumber(index),
          profileImage: owner.profileImage || '',
          name: owner.name || '',
          company: owner.companyName || '',
          email: owner.email || '',
          phone: owner.phone || '',
          buses: owner.busCount || 0,
          routes: owner.routeCount || 0,
          joined: new Date(owner.createdAt).toISOString().split('T')[0],
          status: owner.isVerified ? 'Verified' : 'Pending',
          adminApproval: owner.isApprovedByAdmin ? 'Approved' : 'Pending',
          _id: owner._id,
          isVerified: owner.isVerified,
          isProfileComplete: owner.isProfileComplete,
          isApprovedByAdmin: owner.isApprovedByAdmin,
          activeBuses: owner.activeBuses || 0,
          driverCount: owner.driverCount || 0,
          conductorCount: owner.conductorCount || 0,
          createdAt: owner.createdAt,
          updatedAt: owner.updatedAt,
          address: owner.address || {},
          city: owner.address?.city || '',
          state: owner.address?.state || owner.state || '',
          pincode: owner.address?.pincode || '',
          busAll: owner.busAll || [],
          isPending: false,
          source: 'regular'
        }));

        setBusOwners(transformedOwners);

        if (response.totalPages) {
          setTotalPages(response.totalPages);
        }
        if (response.total) {
          setTotalOwners(response.total);
        } else {
          setTotalOwners(response.busOwners.length);
        }
      } else {
        setError('No bus owners data found in response');
        setBusOwners([]);
        setTotalPages(1);
        setTotalOwners(0);
      }
    } catch (err) {
      console.error('Error fetching bus owners:', err);
      setError('Failed to fetch bus owners. Please try again.');
      setBusOwners([]);
      setTotalPages(1);
      setTotalOwners(0);
    } finally {
      setLoading(false);
      setSearching(false);
    }
  };

  const fetchPendingBusOwners = async () => {
    try {
      setLoadingPending(true);
      setError(null);

      const response = await getPendingBusOwners(token);

      if (response && response.success) {
        const transformedOwners = response.data.map((owner, index) => ({
          id: owner._id,
          pendingId: owner._id,
          serialNo: index + 1,
          profileImage: owner.profileImage || '',
          name: owner.name || '',
          company: owner.companyName || '',
          email: owner.email || '',
          phone: owner.phone || '',
          buses: 0,
          routes: 0,
          joined: new Date(owner.createdAt).toISOString().split('T')[0],
          status: 'Pending',
          adminApproval: 'Pending',
          _id: owner._id,
          isVerified: false,
          isProfileComplete: false,
          isApprovedByAdmin: false,
          activeBuses: 0,
          driverCount: 0,
          conductorCount: 0,
          createdAt: owner.createdAt,
          updatedAt: owner.updatedAt,
          address: owner.address || {},
          city: owner.address?.city || '',
          state: owner.address?.state || '',
          pincode: owner.address?.pincode || '',
          busAll: [],
          isPending: true,
          source: 'pending',
          submittedBy: owner.submittedBy,
          submittedByName: owner.submittedByName,
          submittedByEmail: owner.submittedByEmail,
          operationType: owner.operationType,
          status: owner.status,
          approvalStatus: owner.approvalStatus,
          originalData: owner.originalData
        }));

        setPendingOwners(transformedOwners);
        setTotalOwners(transformedOwners.length);
        setTotalPages(1);
      } else {
        setPendingOwners([]);
        setTotalOwners(0);
        setTotalPages(1);
      }
    } catch (err) {
      console.error('Error fetching pending bus owners:', err);
      setError('Failed to fetch pending bus owners. Please try again.');
      setPendingOwners([]);
    } finally {
      setLoadingPending(false);
    }
  };

  useEffect(() => {
    if (viewMode === 'regular') {
      fetchBusOwners();
    } else {
      fetchPendingBusOwners();
    }
  }, [viewMode, currentPage, searchTerm]);

  const refreshPendingOwners = async () => {
    await fetchPendingBusOwners();
  };

  const getCurrentOwners = () => {
    return viewMode === 'regular' ? busOwners : pendingOwners;
  };

  const getCurrentLoading = () => {
    return viewMode === 'regular' ? loading : loadingPending;
  };

  const currentOwners = getCurrentOwners();
  const isLoading = getCurrentLoading();

  const handleApprovePendingOwner = async (pendingId) => {
    try {
      setError(null);
      const response = await approvePendingBusOwner(pendingId, token);

      if (response.success) {
        toast.success('Pending bus owner approved successfully!');
        setPendingOwners(prev => prev.filter(owner => owner.id !== pendingId));
        setTotalOwners(prev => prev - 1);
        await fetchBusOwners();
      } else {
        throw new Error(response.message || 'Failed to approve pending bus owner');
      }
    } catch (err) {
      console.error('Error approving pending bus owner:', err);
      setError('Failed to approve pending bus owner. Please try again.');
      toast.error('Failed to approve pending bus owner. Please try again.');
    }
  };

  const handleRejectPendingOwner = async (pendingId) => {
    if (!window.confirm('Are you sure you want to reject this pending bus owner?')) return;

    try {
      setError(null);
      const response = await rejectPendingBusOwner(pendingId, token);

      if (response.success) {
        toast.success('Pending bus owner rejected successfully!');
        setPendingOwners(prev => prev.filter(owner => owner.id !== pendingId));
        setTotalOwners(prev => prev - 1);
      } else {
        throw new Error(response.message || 'Failed to reject pending bus owner');
      }
    } catch (err) {
      console.error('Error rejecting pending bus owner:', err);
      setError('Failed to reject pending bus owner. Please try again.');
      toast.error('Failed to reject pending bus owner. Please try again.');
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const fetchBusOwnerById = async (id) => {
    try {
      const response = await getBusOwnerById(id, token);
      return response.data || response;
    } catch (err) {
      console.error('Error fetching bus owner:', err);
      throw err;
    }
  };

  const handleApproveOwner = async (ownerId) => {
    try {
      setError(null);
      const response = await approveBusOwner(ownerId, token);

      if (response.success) {
        setBusOwners(prevOwners =>
          prevOwners.map(owner =>
            owner.id === ownerId ? {
              ...owner,
              isApprovedByAdmin: response.data?.isApprovedByAdmin || true,
              adminApproval: (response.data?.isApprovedByAdmin || true) ? 'Approved' : 'Pending',
              isVerified: response.data?.isVerified || true,
              status: response.data?.isVerified ? 'Verified' : 'Pending'
            } : owner
          )
        );
        toast.success('Bus owner approved and verified successfully!');
      } else {
        throw new Error(response.message || 'Failed to approve bus owner');
      }
    } catch (err) {
      console.error('Error approving bus owner:', err);
      setError('Failed to approve bus owner. Please try again.');
      toast.error('Failed to approve bus owner. Please try again.');
    }
  };

  const handleManageBuses = async (owner) => {
    if (owner.buses === 0) {
      toast.error("This owner has no buses registered");
      return;
    }

    if (!owner.busAll || owner.busAll.length === 0) {
      try {
        setBusDetailsLoading(true);
        const response = await getBusOwnerById(owner.id, token);

        if (response.success && response.data && response.data.busAll) {
          const updatedOwner = {
            ...owner,
            busAll: response.data.busAll || []
          };

          const processedBuses = updatedOwner.busAll.map(bus => {
            const driver = bus.driver ? {
              name: bus.driver.name || 'N/A',
              contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
              licenseNumber: bus.driver.licenseNumber || 'N/A',
              experience: bus.driver.experience || 0
            } : null;

            const conductor = bus.conductor ? {
              name: bus.conductor.name || 'N/A',
              contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
            } : null;

            return {
              ...bus,
              driver,
              conductor
            };
          });

          setSelectedOwner(updatedOwner);
          setSelectedOwnerBuses(processedBuses);
          setShowBusManagement(true);
          setBusSearchTerm('');
        } else {
          toast.error('Could not fetch bus data. Please try again.');
        }
      } catch (err) {
        console.error('Error fetching bus details:', err);
        toast.error('Failed to fetch bus details. Please try again.');
      } finally {
        setBusDetailsLoading(false);
      }
      return;
    }

    const processedBuses = owner.busAll.map(bus => {
      const driver = bus.driver ? {
        name: bus.driver.name || 'N/A',
        contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
        licenseNumber: bus.driver.licenseNumber || 'N/A',
        experience: bus.driver.experience || 0
      } : null;

      const conductor = bus.conductor ? {
        name: bus.conductor.name || 'N/A',
        contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
      } : null;

      return {
        ...bus,
        driver,
        conductor
      };
    });

    setSelectedOwner(owner);
    setSelectedOwnerBuses(processedBuses);
    setShowBusManagement(true);
    setBusSearchTerm('');
  };

  const filteredBuses = selectedOwnerBuses.filter(bus =>
    (bus.busName && bus.busName.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
    (bus.busNumber && bus.busNumber.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
    (bus.driver?.name && bus.driver.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
    (bus.conductor?.name && bus.conductor.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
    (bus.driver?.contactNumber && bus.driver.contactNumber.includes(busSearchTerm)) ||
    (bus.conductor?.contactNumber && bus.conductor.contactNumber.includes(busSearchTerm))
  );

  const handleRejectOwner = async (ownerId) => {
    if (window.confirm('Are you sure you want to reject this bus owner?')) {
      try {
        setError(null);

        if (!ownerId || typeof ownerId !== 'string') {
          throw new Error('Invalid owner ID');
        }

        const response = await updateBusOwner(ownerId, { isApprovedByAdmin: false }, token);

        if (response.success) {
          setBusOwners(prevOwners =>
            prevOwners.map(owner =>
              owner.id === ownerId ? {
                ...owner,
                isApprovedByAdmin: response.data?.isApprovedByAdmin || false,
                adminApproval: (response.data?.isApprovedByAdmin || false) ? 'Approved' : 'Rejected'
              } : owner
            )
          );
          toast.success('Bus owner rejected successfully!');
        } else {
          throw new Error(response.message || 'Failed to reject bus owner');
        }
      } catch (err) {
        console.error('Error rejecting bus owner:', err);
        setError('Failed to reject bus owner. Please try again.');
        toast.error('Failed to reject bus owner. Please try again.');
      }
    }
  };

  const filteredOwners = currentOwners;

const handleViewOwner = async (owner) => {
  try {
    setError(null);

    let response;
    let ownerData;
    
    if (owner.isPending) {
      response = await getPendingBusOwnerById(owner.id, token);
      if (response.success) {
        ownerData = response.data;
        setViewingOwner({
          id: ownerData._id,
          name: ownerData.name || '',
          company: ownerData.companyName || '',
          email: ownerData.email || '',
          phone: ownerData.phone || '',
          profileImage: ownerData.profileImage,
          address: ownerData.address || {},
          isVerified: false,
          isProfileComplete: false,
          isApprovedByAdmin: false,
          busCount: 0,
          activeBuses: 0,
          driverCount: 0,
          conductorCount: 0,
          routes: [],
          buses: [],
          bankDetails: null,
          status: 'Pending',
          joined: new Date(ownerData.createdAt).toLocaleDateString(),
          isPending: true,
          submittedBy: ownerData.submittedBy,
          submittedByName: ownerData.submittedByName,
          submittedByEmail: ownerData.submittedByEmail,
          operationType: ownerData.operationType
        });
      }
    } else {
      ownerData = await fetchBusOwnerById(owner.id);
      setViewingOwner({
        ...owner,
        profileImage: ownerData.profileImage || owner.profileImage,
        name: ownerData.name || owner.name,
        company: ownerData.companyName || owner.company,
        email: ownerData.email || owner.email,
        phone: ownerData.phone || owner.phone,
        address: ownerData.address || owner.address,
        isVerified: ownerData.isVerified,
        isProfileComplete: ownerData.isProfileComplete,
        isApprovedByAdmin: ownerData.isApprovedByAdmin,
        busCount: ownerData.stats?.busCount || 0,
        activeBuses: ownerData.stats?.activeBuses || 0,
        driverCount: ownerData.stats?.driverCount || 0,
        conductorCount: ownerData.stats?.conductorCount || 0,
        routes: ownerData.routes || [],
        buses: ownerData.buses || [],
        bankDetails: ownerData.bankDetails || ownerData.bankAccount || null,
        status: ownerData.isApprovedByAdmin ? 'Active' : 'Pending',
        joined: ownerData.createdAt
          ? new Date(ownerData.createdAt).toLocaleDateString()
          : owner.joined,
      });
    }
  } catch (err) {
    console.error('Error fetching owner details:', err);
    setError('Failed to fetch owner details.');
    toast.error('Failed to fetch owner details. Please try again.');
  } 
};

  const handleEditOwner = (owner) => {
    setEditingOwner(owner.id);
    setEditForm({
      name: owner.name || '',
      companyName: owner.company || '',
      email: owner.email || '',
      phone: owner.phone || '',
      status: owner.status || 'Pending',
      isApprovedByAdmin: owner.isApprovedByAdmin || false
    });
  };

  const closeBusManagement = () => {
    setShowBusManagement(false);
    setSelectedOwnerBuses([]);
    setSelectedOwner(null);
  };

const handleSaveEdit = async () => {
  try {
    setError(null);

    if (!editingOwner || typeof editingOwner !== 'string') {
      throw new Error('Invalid owner ID for editing');
    }

    const updateData = {
      name: editForm.name,
      email: editForm.email,
      phone: editForm.phone,
      companyName: editForm.companyName,
    };

    if (isEditingPending) {
      const response = await updatePendingBusOwner(editingOwner, updateData, token);

      if (response.success) {
        setPendingOwners(prevOwners =>
          prevOwners.map(owner =>
            owner.id === editingOwner ? {
              ...owner,
              name: response.data.name || editForm.name,
              company: response.data.companyName || editForm.companyName,
              email: response.data.email || editForm.email,
              phone: response.data.phone || editForm.phone,
            } : owner
          )
        );
        toast.success('Pending bus owner updated successfully!');
        
        setEditingOwner(null);
        setEditForm({});
        setIsEditingPending(false);
        return;
      } else {
        throw new Error(response.message || 'Failed to update pending bus owner');
      }
    }

    const regularUpdateData = {
      ...updateData,
      isVerified: editForm.status === 'Verified',
      isApprovedByAdmin: editForm.isApprovedByAdmin || false
    };

    const response = await updateBusOwner(editingOwner, regularUpdateData, token);

    if (response.success) {
      setBusOwners(prevOwners =>
        prevOwners.map(owner =>
          owner.id === editingOwner ? {
            ...owner,
            name: response.data?.name || editForm.name,
            company: response.data?.companyName || editForm.companyName,
            email: response.data?.email || editForm.email,
            phone: response.data?.phone || editForm.phone,
            status: response.data?.isVerified ? 'Verified' : 'Pending',
            isVerified: response.data?.isVerified,
            isApprovedByAdmin: response.data?.isApprovedByAdmin,
            adminApproval: response.data?.isApprovedByAdmin ? 'Approved' : 'Pending'
          } : owner
        )
      );

      setEditingOwner(null);
      setEditForm({});
      toast.success('Bus owner updated successfully!');
    } else {
      throw new Error(response.message || 'Failed to update bus owner');
    }
  } catch (err) {
    console.error('Error updating bus owner:', err);
    setError('Failed to update bus owner. Please try again.');
    toast.error(err.message || 'Failed to update bus owner. Please try again.');
  }
};

  const handleCancelEdit = () => {
    setEditingOwner(null);
    setEditForm({});
    setError(null);
    setIsEditingPending(false);
  };

  const handleDeleteOwner = async (ownerId) => {
    if (window.confirm('Are you sure you want to delete this bus owner?')) {
      try {
        setError(null);
        const response = await deleteBusOwner(ownerId, token);

        if (response.success) {
          setBusOwners(prevOwners => prevOwners.filter(owner => owner.id !== ownerId));
          setTotalOwners(prev => prev - 1);
          toast.success('Bus owner deleted successfully!');
        } else {
          throw new Error(response.message || 'Failed to delete bus owner');
        }
      } catch (err) {
        console.error('Error deleting bus owner:', err);
        const errorMessage = err.response?.data?.message || err.message || 'Failed to delete bus owner. Please try again.';
        setError(errorMessage);
        toast.error(errorMessage);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleNewOwnerChange = (e) => {
    const { name, value } = e.target;
    setNewOwner(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAddOwner = async () => {
    try {
      setError(null);

      if (!newOwner.name || !newOwner.email || !newOwner.phone || !newOwner.companyName) {
        toast.error('Please fill in all required fields');
        return;
      }

      const response = await createBusOwner(newOwner, token);

      if (response.success) {
        const newOwnerWithId = {
          id: response.data.id,
          serialNo: busOwners.length + 1,
          profileImage: '',
          name: response.data.name,
          company: response.data.companyName,
          email: response.data.email,
          phone: response.data.phone,
          buses: 0,
          routes: 0,
          joined: new Date(response.data.createdAt).toISOString().split('T')[0],
          status: 'Pending',
          adminApproval: 'Pending',
          isVerified: false,
          isApprovedByAdmin: false,
          createdAt: response.data.createdAt
        };

        setBusOwners(prev => [newOwnerWithId, ...prev]);
        setTotalOwners(prev => prev + 1);
        setShowAddModal(false);
        setNewOwner({
          name: '',
          companyName: '',
          email: '',
          phone: ''
        });
        setSearchTerm('');
        toast.success('Bus owner added successfully!');
      } else {
        throw new Error(response.message || 'Failed to add bus owner');
      }
    } catch (err) {
      console.error('Error adding bus owner:', err);
      let errorMessage = 'Failed to add bus owner. Please try again.';

      if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
      toast.error(errorMessage);
    }
  };

  const closeViewModal = () => {
    setViewingOwner(null);
  };

  const closeAddModal = () => {
    setShowAddModal(false);
    setNewOwner({
      name: '',
      companyName: '',
      email: '',
      phone: ''
    });
    setError(null);
  };

  const handleRefresh = () => {
    setSearchTerm('');
    setCurrentPage(1);
    if (viewMode === 'regular') {
      fetchBusOwners();
    } else {
      fetchPendingBusOwners();
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const currentPageOwners = currentOwners;
  const verifiedOwners = currentPageOwners.filter(o => o.status === 'Verified').length;
  const approvedOwners = currentPageOwners.filter(o => o.isApprovedByAdmin).length;
  const totalBuses = currentPageOwners.reduce((sum, owner) => sum + owner.buses, 0);

  const handleAddBusClick = (owner) => {
    setSelectedOwnerForBus(owner);
    setShowAddBusModal(true);
  };

  const handleBusAdded = () => {
    if (viewMode === 'regular') {
      fetchBusOwners();
    } else {
      fetchPendingBusOwners();
    }
    toast.success('Bus added successfully!');
  };

  const closeAddBusModal = () => {
    setShowAddBusModal(false);
    setSelectedOwnerForBus(null);
  };

  const refreshBusList = async () => {
    if (!selectedOwner) return;

    try {
      setBusDetailsLoading(true);
      const response = await getBusOwnerById(selectedOwner.id, token);

      if (response.success && response.data) {
        const busData = response.data.busAll || response.data.buses || [];

        const processedBuses = busData.map(bus => {
          const driver = bus.driver ? {
            name: bus.driver.name || 'N/A',
            contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
            licenseNumber: bus.driver.licenseNumber || 'N/A',
            experience: bus.driver.experience || 0
          } : null;

          const conductor = bus.conductor ? {
            name: bus.conductor.name || 'N/A',
            contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
          } : null;

          return { ...bus, driver, conductor };
        });

        setSelectedOwnerBuses(processedBuses);

        setSelectedOwner(prev => ({
          ...prev,
          busAll: busData
        }));
      }
    } catch (err) {
      console.error('Error refreshing bus list:', err);
      toast.error('Failed to refresh bus list');
    } finally {
      setBusDetailsLoading(false);
    }
  };

  if (isLoading && currentOwners.length === 0) {
    return (
      <div className="management-page">
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="stats-cards">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <SkeletonTable />

        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="management-page">
      <div className="page-header">
        <h1>Bus Owner Management</h1>
        <div className="header-actions">
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              placeholder="Search bus owners by name, company, email or phone..."
              className="search-input"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ width: "70%" }}
            />
            {searching && (
              <span style={{
                position: 'absolute', right: '10px', top: '50%',
                transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
              }}>
                searching...
              </span>
            )}
          </div>

          <button className="refresh-btn" onClick={handleRefresh}>
            Refresh
          </button>
          {viewMode === 'regular' && (
            <button className="add-btn" onClick={() => setShowAddModal(true)}>
              + Add Owner
            </button>
          )}
        </div>
      </div>

      <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
        {viewMode === 'regular' ? (
          <>Page: {currentPage} | Total Pages: {totalPages} | Total Owners: {totalOwners}</>
        ) : (
          <>Pending Owners: {pendingOwners.length} | {loadingPending ? 'Loading...' : ''}</>
        )}
      </div>

      <div className="stats-cards">
        <div className="stat-card">
          <h3>Total {viewMode === 'regular' ? 'Owners' : 'Pending Owners'}</h3>
          <p>{totalOwners}</p>
          <span>{viewMode === 'regular' ? 'All registered owners' : 'Awaiting approval'}</span>
        </div>
        <div className="stat-card">
          <h3>Verified Owners</h3>
          <p>{verifiedOwners}</p>
          <span>Verified on page {currentPage}</span>
        </div>
        <div className="stat-card">
          <h3>Approved Owners</h3>
          <p>{approvedOwners}</p>
          <span>Approved on page {currentPage}</span>
        </div>
        <div className="stat-card">
          <h3>Total Buses</h3>
          <p>{totalBuses}</p>
          <span>active fleet</span>
        </div>
      </div>

      <div className="view-toggle-group" style={{ display: 'flex', gap: '10px', alignItems: 'center', margin: '0 15px' }}>
        <button
          className={`toggle-btn ${viewMode === 'regular' ? 'active' : ''}`}
          onClick={() => {
            setViewMode('regular');
            setCurrentPage(1);
            setSearchTerm('');
          }}
          style={{
            padding: '8px 20px',
            borderRadius: '20px',
            border: '2px solid #007bff',
            backgroundColor: viewMode === 'regular' ? '#007bff' : 'transparent',
            color: viewMode === 'regular' ? 'white' : '#007bff',
            cursor: 'pointer',
            fontWeight: '500',
            transition: 'all 0.3s'
          }}
        >
          👤 Regular
        </button>
        <button
          className={`toggle-btn ${viewMode === 'pending' ? 'active' : ''}`}
          onClick={() => {
            setViewMode('pending');
            setCurrentPage(1);
            setSearchTerm('');
          }}
          style={{
            padding: '8px 20px',
            borderRadius: '20px',
            border: '2px solid #ff9800',
            backgroundColor: viewMode === 'pending' ? '#ff9800' : 'transparent',
            color: viewMode === 'pending' ? 'white' : '#ff9800',
            cursor: 'pointer',
            fontWeight: '500',
            transition: 'all 0.3s',
            position: 'relative'
          }}
        >
          📋 Executive Submitted
          {viewMode === 'pending' && pendingOwners.length > 0 && (
            <span style={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
              backgroundColor: 'red',
              color: 'white',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              fontSize: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold'
            }}>
              {pendingOwners.length}
            </span>
          )}
        </button>
      </div>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Profile</th>
              <th>Owner Name</th>
              <th>Company</th>
              <th>Contact</th>
              <th>Buses</th>
              <th>Admin Approval</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredOwners.length > 0 ? (
              filteredOwners.map(owner => (
                <tr key={owner.id} style={owner.isPending ? { backgroundColor: '#fff3e0' } : {}}>
                  <td>{owner.serialNo}</td>
                  <td>
                    <div className="profile-image-cell">
                      <img
                        src={getFullImageUrl(owner.profileImage)}
                        alt={owner.name || 'Bus Owner'}
                        className="customer-avatar"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '';
                        }}
                      />
                    </div>
                  </td>

                  <td>
                    {editingOwner === owner.id ? (
                      <input
                        type="text"
                        name="name"
                        value={editForm.name || ''}
                        onChange={handleInputChange}
                        className="edit-input"
                        placeholder="Owner Name"
                        style={{ width: '100%', padding: '5px' }}
                      />
                    ) : (
                      <>
                        {owner.name || 'N/A'}
                        {owner.isPending && (
                          <span style={{
                            display: 'inline-block',
                            marginLeft: '8px',
                            fontSize: '10px',
                            backgroundColor: '#ff9800',
                            color: 'white',
                            padding: '2px 8px',
                            borderRadius: '12px'
                          }}>
                            Pending
                          </span>
                        )}
                      </>
                    )}
                  </td>

                  <td>
                    {editingOwner === owner.id ? (
                      <input
                        type="text"
                        name="companyName"
                        value={editForm.companyName || ''}
                        onChange={handleInputChange}
                        className="edit-input"
                        placeholder="Company Name"
                        style={{ width: '100%', padding: '5px' }}
                      />
                    ) : (
                      owner.company || 'N/A'
                    )}
                  </td>

                  <td>
                    {editingOwner === owner.id ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <input
                          type="email"
                          name="email"
                          value={editForm.email || ''}
                          onChange={handleInputChange}
                          className="edit-input"
                          placeholder="Email"
                          style={{ width: '100%', padding: '5px' }}
                        />
                        <input
                          type="text"
                          name="phone"
                          value={editForm.phone || ''}
                          onChange={handleInputChange}
                          className="edit-input"
                          placeholder="Phone"
                          style={{ width: '100%', padding: '5px' }}
                        />
                      </div>
                    ) : (
                      <div>
                        <div>{owner.email || 'N/A'}</div>
                        <div className="phone">{owner.phone || 'N/A'}</div>
                      </div>
                    )}
                  </td>

                  <td>{owner.buses}</td>



                  <td>
  <span className={`status-badge ${owner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
    {owner.isApprovedByAdmin ? 'Approved' : 'Pending'}
  </span>
</td>



                  <td>
  <span className={`status-badge ${owner.status ? owner.status.toLowerCase() : 'pending'}`}>
    {owner.status || 'Pending'}
  </span>
</td>

                  <td>
                    {editingOwner === owner.id ? (
                      <div className="edit-actions" style={{ display: 'flex', gap: '5px' }}>
                        <button
                          className="action-btn save"
                          onClick={handleSaveEdit}
                          style={{ backgroundColor: '#28a745', color: 'white' }}
                        >
                          Save
                        </button>
                        <button
                          className="action-btn cancel"
                          onClick={handleCancelEdit}
                          style={{ backgroundColor: '#6c757d', color: 'white' }}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <div className="action-buttons">


                        {!owner.isPending ? (
                          <>
                            <button
                              className="action-btn view"
                              onClick={() => handleViewOwner(owner)}
                            >
                              View
                            </button>
                            <button
                              className="action-btn edit"
                              onClick={() => handleEditOwner(owner)}
                            >
                              Edit
                            </button>
                            <button
                              className="action-btn add-bus"
                              onClick={() => handleAddBusClick(owner)}
                              style={{
                                backgroundColor: '#007bff',
                                color: 'white'
                              }}
                              title="Add new bus for this owner"
                            >
                              + Add Bus
                            </button>
                            <button
                              className="action-btn manage"
                              onClick={() => handleManageBuses(owner)}
                              style={{
                                backgroundColor: '#007bff',
                                color: 'white'
                              }}
                              title={owner.buses === 0 ? 'No buses available' : 'Manage buses'}
                            >
                              Manage Buses
                            </button>
                            {!owner.isApprovedByAdmin && (
                              <button
                                className="action-btn approve"
                                onClick={() => handleApproveOwner(owner.id)}
                                style={{ backgroundColor: '#28a745' }}
                              >
                                Approve
                              </button>
                            )}
                            {owner.isApprovedByAdmin && (
                              <button
                                className="action-btn reject"
                                onClick={() => handleRejectOwner(owner.id)}
                                style={{ backgroundColor: '#ffc107', color: '#000' }}
                              >
                                Reject
                              </button>
                            )}
                            <button
                              className="action-btn delete"
                              onClick={() => handleDeleteOwner(owner.id)}
                            >
                              Delete
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="action-btn view"
                              onClick={() => handleViewOwner(owner)}
                              style={{ backgroundColor: '#17a2b8' }}
                            >
                              View
                            </button>
                            <button
                              className="action-btn edit"
                              onClick={() => handleEditPendingOwner(owner.id)}
                              style={{ backgroundColor: '#6f42c1', color: 'white' }}
                            >
                              Edit
                            </button>
                            <button
                              className="action-btn approve"
                              onClick={() => handleApprovePendingOwner(owner.id)}
                              style={{ backgroundColor: '#28a745' }}
                            >
                              Approve
                            </button>
                            <button
                              className="action-btn reject"
                              onClick={() => handleRejectPendingOwner(owner.id)}
                              style={{ backgroundColor: '#dc3545' }}
                            >
                              Reject
                            </button>
                            {owner.submittedByName && (
                              <span style={{
                                fontSize: '10px',
                                color: '#666',
                                display: 'block',
                                marginTop: '4px'
                              }}>
                                By: {owner.submittedByName}
                              </span>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="no-data">
                  <p>
                    {viewMode === 'regular'
                      ? `No bus owners found ${searchTerm ? 'matching your search' : ''}.`
                      : 'No pending bus owners from executive submissions.'}
                  </p>
                  {searchTerm && (
                    <button className="clear-filters-link" onClick={handleRefresh}>
                      Clear search to see all bus owners
                    </button>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {filteredOwners.length === 0 && !isLoading && (
          <div className="no-data">
            <p>
              {viewMode === 'regular'
                ? 'No bus owners found matching your search.'
                : 'No pending bus owners from executive submissions.'}
            </p>
          </div>
        )}
      </div>

      {viewMode === 'regular' && (
        <div className="pagination-container">
          <div className="pagination-info">
            Showing {busOwners.length} of {totalOwners} bus owners
            (Page {currentPage} of {totalPages})
            {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
          </div>
          <div className="pagination-controls">
            <button
              className="pagination-btn"
              onClick={handlePrevPage}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            <div className="page-numbers">
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                let pageNumber;
                if (totalPages <= 5) {
                  pageNumber = i + 1;
                } else if (currentPage <= 3) {
                  pageNumber = i + 1;
                } else if (currentPage >= totalPages - 2) {
                  pageNumber = totalPages - 4 + i;
                } else {
                  pageNumber = currentPage - 2 + i;
                }

                return (
                  <button
                    key={pageNumber}
                    className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
                    onClick={() => handlePageClick(pageNumber)}
                  >
                    {pageNumber}
                  </button>
                );
              })}
            </div>

            <button
              className="pagination-btn"
              onClick={handleNextPage}
              disabled={currentPage === totalPages || totalPages === 0}
            >
              Next
            </button>
          </div>
        </div>
      )}


      {viewingOwner && (
        <div className="modal-overlay" onClick={closeViewModal}>
          <div className="modern-dashboard-modal" onClick={(e) => e.stopPropagation()}>
            <header className="dashboard-header">
              <div className="header-left">
                <div className="icon-box"><i className="fas fa-bus"></i></div>
                <div>
                  <h3>Bus Owner Profile</h3>
                  <span className="subtitle">Management Console</span>
                </div>
              </div>
              <button className="close-icon-btn" onClick={closeViewModal}>&times;</button>
            </header>

            <div className="dashboard-body">
              <section className="profile-overview-card">
                <div className="owner-brand">
                  <div className="avatar-wrapper">
                    <img
                      src={getFullImageUrl(viewingOwner.profileImage)}
                      alt="Profile"
                      onError={(e) => { e.target.src = ''; }}
                    />
                    {viewingOwner.isVerified && <div className="verified-badge"><i className="fas fa-check"></i></div>}
                  </div>
                  <div className="brand-details">
                    <h2>{viewingOwner.name || 'N/A'}</h2>
                    <p className="owner-id-tag">ID: {viewingOwner.id}</p>
                    <div className="quick-tags">
                      <span className={`tag ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
                        {viewingOwner.isApprovedByAdmin ? 'Verified Partner' : 'Pending Review'}
                      </span>
                      <span className="tag city-tag"><i className="fas fa-map-marker-alt"></i> {viewingOwner.address?.city}, {viewingOwner.address?.state}</span>
                    </div>
                  </div>
                </div>

                <div className="stats-strip">
                  <div className="stat-node">
                    <label>Buses</label>
                    <div className="value">{viewingOwner.busCount || 0}</div>
                  </div>
                  <div className="stat-node">
                    <label>Drivers</label>
                    <div className="value">{viewingOwner.driverCount || 0}</div>
                  </div>
                  <div className="stat-node">
                    <label>Conductors</label>
                    <div className="value">{viewingOwner.conductorCount || 0}</div>
                  </div>
                </div>
              </section>

              <section className="content-group">
                <div className="section-title">
                  <h4><i className="fas fa-route"></i> Active Routes</h4>
                </div>
                <div className="row-wise-container">
                  {viewingOwner.routes?.map((route, index) => (
                    <div key={index} className="modern-row-card route-row">
                      <div className="row-main-info">
                        <div className="route-code">{route.routeNumber}</div>
                        <div className="journey-stepper">
                          <span className="">{route.origin?.city}</span>
                          <div className="connector-line">
                            <i className="fas fa-chevron-right"></i>
                          </div>
                          <span className="">{route.destination?.city}</span>
                        </div>
                      </div>
                      <div className="row-meta-info">
                        <div className="meta-item"><i className="fas fa-road"></i> {route.routeDetails?.totalDistance} km</div>
                        <div className="meta-item"><i className="fas fa-clock"></i> {route.routeDetails?.estimatedDuration?.hours}h {route.routeDetails?.estimatedDuration?.minutes}m</div>
                        <div className="meta-item bus-pill"><i className="fas fa-bus-alt"></i> {route.busCount} assigned</div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>

              <section className="content-group">
                <div className="section-title">
                  <h4><i className="fas fa-shuttle-van"></i> Bus Details</h4>
                </div>
                <div className="row-wise-container">
                  {viewingOwner.buses?.map((bus, index) => (
                    <div key={index} className="modern-row-card bus-row">
                      <div className="bus-identity">
                        <div className={`status-indicator ${bus.isActive ? 'online' : 'offline'}`}></div>
                        <div>
                          <strong>{bus.busName}</strong>
                          <div className="plate-number">{bus.busNumber}</div>
                        </div>
                      </div>

                      <div className="bus-specs-row">
                        <span><i className="fas fa-chair"></i> {bus.totalSeats} Seats</span>
                        <span><i className="fas fa-snowflake"></i> {bus.busType}</span>
                      </div>

                      <div className="bus-amenities-tags">
                        {bus.amenities?.slice(0, 2).map((a, i) => <span key={i} className="mini-tag">{a}</span>)}
                      </div>
                    </div>
                  ))}
                </div>
              </section>

              {viewingOwner.bankDetails && (
                <section className="content-group">
                  <div className="section-title">
                    <h4><i className="fas fa-university"></i> Bank Details</h4>
                  </div>
                  <div className="row-wise-container">
                    <div className="modern-row-card bank-row">
                      <div className="bank-details-grid">
                        {viewingOwner.bankDetails.accountHolderName && (
                          <div className="bank-detail-item">
                            <label>Account Holder</label>
                            <span>{viewingOwner.bankDetails.accountHolderName}</span>
                          </div>
                        )}
                        {viewingOwner.bankDetails.bankName && (
                          <div className="bank-detail-item">
                            <label>Bank Name</label>
                            <span>{viewingOwner.bankDetails.bankName}</span>
                          </div>
                        )}
                        {viewingOwner.bankDetails.accountNumber && (
                          <div className="bank-detail-item">
                            <label>Account Number</label>
                            <span>{viewingOwner.bankDetails.accountNumber}</span>
                          </div>
                        )}
                        {viewingOwner.bankDetails.ifscCode && (
                          <div className="bank-detail-item">
                            <label>IFSC Code</label>
                            <span>{viewingOwner.bankDetails.ifscCode}</span>
                          </div>
                        )}
                        {viewingOwner.bankDetails.branchName && (
                          <div className="bank-detail-item">
                            <label>Branch</label>
                            <span>{viewingOwner.bankDetails.branchName}</span>
                          </div>
                        )}
                        {viewingOwner.bankDetails.upiId && (
                          <div className="bank-detail-item">
                            <label>UPI ID</label>
                            <span>{viewingOwner.bankDetails.upiId}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              )}
            </div>

            <footer className="dashboard-footer">
              <button className="btn-secondary" onClick={closeViewModal}>Close</button>
            </footer>
          </div>
        </div>
      )}


      {showBusManagement && selectedOwner && (
        <BusManagementModal
          key={busUpdateTrigger}
          owner={selectedOwner}
          buses={selectedOwnerBuses}
          onClose={closeBusManagement}
          onUpdate={async () => {
            await refreshBusList();
            if (viewMode === 'regular') {
              await fetchBusOwners();
            } else {
              await fetchPendingBusOwners();
            }
          }}
        />
      )}


      {showAddModal && (
        <div className="modal-overlay" onClick={closeAddModal}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Add New Bus Owner</h3>
              <button className="modal-close-btn" onClick={closeAddModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="customer-details">
                <div className="detail-row">
                  <label>Owner Name *:</label>
                  <input
                    type="text"
                    name="name"
                    value={newOwner.name}
                    onChange={handleNewOwnerChange}
                    className="edit-input"
                    placeholder="Enter owner name"
                    required
                  />
                </div>
                <div className="detail-row">
                  <label>Company Name *:</label>
                  <input
                    type="text"
                    name="companyName"
                    value={newOwner.companyName}
                    onChange={handleNewOwnerChange}
                    className="edit-input"
                    placeholder="Enter company name"
                    required
                  />
                </div>
                <div className="detail-row">
                  <label>Email *:</label>
                  <input
                    type="email"
                    name="email"
                    value={newOwner.email}
                    onChange={handleNewOwnerChange}
                    className="edit-input"
                    placeholder="Enter email address"
                    required
                  />
                </div>
                <div className="detail-row">
                  <label>Phone *:</label>
                  <input
                    type="text"
                    name="phone"
                    value={newOwner.phone}
                    onChange={handleNewOwnerChange}
                    className="edit-input"
                    placeholder="Enter phone number"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="action-btn cancel" onClick={closeAddModal}>
                Cancel
              </button>
              <button className="action-btn save" onClick={handleAddOwner}>
                Add Owner
              </button>
            </div>
          </div>
        </div>
      )}


      {showAddBusModal && selectedOwnerForBus && (
        <AddBusModal
          ownerId={selectedOwnerForBus.id}
          onClose={closeAddBusModal}
          onBusAdded={handleBusAdded}
        />
      )}
    </div>
  );
};

export default BusOwnerManage;